/**
 * PS Finder — Parts Stop contextual parts search engine
 * Delivered as: assets/ps-finder.js
 * Loaded via: snippets/ps-finder.liquid → layout/theme.liquid
 * Version: 1.0.0
 */

(function () {
  'use strict';

  // ─── Variant ID lookup table ─────────────────────────────────────────────────
  const VARIANT_IDS = {
    // Hubs
    'HC4': 49910007103765,
    'HM4': 49910013985045,
    'HD4': 49910015295765,
    'HG4': 49910015885589,
    'HF5': 49901266141461,
    '422300F5': 49910016868629,
    '428300F5': 49910017229077,
    'HDPF': 49910017327381,
    'HT5': 49901268402453,
    '422300T5': 49910017425685,
    '428300T5': 49910017556757,
    'HQ5': 49910017655061,
    '422300Q5': 49910019260693,
    '428300Q5': 49910019752213,
    'HCD5': 49910020505877,
    '422300CD5': 49910022275349,
    '428300CD5': 49910022897941,
    'HDPT5': 49910023356693,
    'HT6': 49910024601877,
    'HPT6': 49901276102933,
    '422300T6': 49910027780373,
    '428300T6': 49901282754837,
    'HDPT6': 49910028206357,
    'MHD12TL6-2T': 49910028468501,
    'MHD12TL6-3T': 49910029222165,
    'SADT5': 49910029582613,
    'SADF5': 49910030205205,
    'HUBDISC2': 49910031122709,
    'HUBDISC120': 49910031286549,
    // Bearing kits
    'LMA1SPK': 49901339443477,
    'LMA1SMPK': 49901371490581,
    'LMBSPK': 49901348290837,
    'LMBSMPK': 49901371654421,
    'LMPSPK': 49901356253461,
    '2TE-LC6': 49906838143253,
    '3TF-LC6': 49906840338709,
    // Dust caps
    'GRSCAP2': 49901334724885,
    'GRSCAP2.5': 49901336461589,
    'DC62': 49909967257877,
    'GC3': 49909968666901,
    // Wheel nuts
    'WN1/2': 49901323354389,
    'WN7/16': 49901325451541,
    '490451SP': 49906796069141,
    // Studs
    '490200E': 49909973418261,
    '490300E': 49909975056661,
    '490400': 49909984428309,
    // Batteries — Exide
    'DIN55MF': 49913448268053,
    'XDIN55MF': 49913447514389,
    'DIN44MF': 49913446498581,
    'XDIN44MF': 49913446072597,
    '40CPMF': 49913445122325,
    'X40CPMF': 49913441190165,
    '40CMF': 49913440895253,
    'X40DPMF': 49913435488533,
    'X40CMF': 49913434505493,
    'DIN77MF': 49913433817365,
    'XDIN77MF': 49913432277269,
    '55D23DMF': 49913430081813,
    'X55D23DMF': 49913429623061,
    'XP55D23DMF': 49913428967701,
    'DIN66HMF': 49913428738325,
    'XDIN66HMF': 49913427722517,
    '55D23CMF': 49913425494293,
    'X55D23CMF': 49913424216341,
    'XP55D23CMF': 49913423462677,
    // Upsells
    '0707.82': 49808471392533,
    'CSMD': 49910032793877,
    'K/AC51/400G': 49888022790421,
    'K/AC55/20': 49888022823189,
    '630020': 49910036889877,
    '1781': 49910033547541,
  };

  // ─── Product data ────────────────────────────────────────────────────────────
  const TYPE_LABELS = {
    lazy: 'Lazy Hub',
    parallel_lazy: 'Parallel Lazy Hub',
    hydraulic: 'Hydraulic Drum Brake',
    electric: 'Electric Drum Brake',
    parallel_electric: 'Parallel Electric Drum',
    disc: 'Disc Brake',
    electric_12: 'Electric Drum (12")',
  };

  const H = [
    { sku:'HC4', name:'Cortina Hub', studs:4, pcd:'4/107.95', cc:'76.33mm', make:'ford', label:'Ford Cortina', lcSize:null, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:4 },
    { sku:'HM4', name:'Mini Hub', studs:4, pcd:'4/101.6', cc:'71.84mm', make:'mini', label:'Mini', lcSize:null, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:4 },
    { sku:'HD4', name:'Datsun Hub', studs:4, pcd:'4/114.3', cc:'80.82mm', make:'datsun', label:'Toyota/Datsun', lcSize:null, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:4 },
    { sku:'HG4', name:'Gemini Hub', studs:4, pcd:'4/100', cc:'70.70mm', make:'holden', label:'Holden Gemini', lcSize:null, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:4, note:'Hub nose may be too large for some rims' },
    { sku:'HF5', name:'Ford Hub', studs:5, pcd:'5/114.3', cc:'67.18mm', make:'ford', label:'Ford', lcSize:null, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN1/2', nutThread:'1/2"', nutQty:5 },
    { sku:'422300F5', name:'Ford Hub, 9" Hydraulic Drum', studs:5, pcd:'5/114.3', cc:'67.18mm', make:'ford', label:'Ford', lcSize:null, type:'hydraulic', bk:'AB', cap:'GRSCAP2', nutSku:'WN1/2', nutThread:'1/2"', nutQty:5 },
    { sku:'428300F5', name:'Ford Hub, 10" Electric Drum', studs:5, pcd:'5/114.3', cc:'67.18mm', make:'ford', label:'Ford', lcSize:null, type:'electric', bk:'AB', cap:'GRSCAP2', nutSku:'WN1/2', nutThread:'1/2"', nutQty:5 },
    { sku:'HDPF', name:'Ford Hub, 10" Parallel Electric', studs:5, pcd:'5/114.3', cc:'67.18mm', make:'ford', label:'Ford', lcSize:null, type:'parallel_electric', bk:'PB', cap:'GRSCAP2.5', nutSku:'WN1/2', nutThread:'1/2"', nutQty:5 },
    { sku:'HT5', name:'Holden HT Hub', studs:5, pcd:'5/107.95', cc:'63.45mm', make:'holden', label:'Holden HT', lcSize:null, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'422300T5', name:'Holden HT Hub, 9" Hydraulic Drum', studs:5, pcd:'5/107.95', cc:'63.45mm', make:'holden', label:'Holden HT', lcSize:null, type:'hydraulic', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'428300T5', name:'Holden HT Hub, 10" Electric Drum', studs:5, pcd:'5/107.95', cc:'63.45mm', make:'holden', label:'Holden HT', lcSize:null, type:'electric', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'HQ5', name:'Holden HQ Hub', studs:5, pcd:'5/120.65', cc:'70.91mm', make:'holden', label:'Holden HQ', lcSize:null, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'422300Q5', name:'Holden HQ Hub, 10" Hydraulic Drum', studs:5, pcd:'5/120.65', cc:'70.91mm', make:'holden', label:'Holden HQ', lcSize:null, type:'hydraulic', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'428300Q5', name:'Holden HQ Hub, 10" Electric Drum', studs:5, pcd:'5/120.65', cc:'70.91mm', make:'holden', label:'Holden HQ', lcSize:null, type:'electric', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'HCD5', name:'Holden Commodore Hub', studs:5, pcd:'5/120', cc:'70.53mm', make:'holden', label:'Holden Commodore', lcSize:null, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'422300CD5', name:'Holden Commodore Hub, 9" Hydraulic Drum', studs:5, pcd:'5/120', cc:'70.53mm', make:'holden', label:'Holden Commodore', lcSize:null, type:'hydraulic', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'428300CD5', name:'Holden Commodore Hub, 10" Electric Drum', studs:5, pcd:'5/120', cc:'70.53mm', make:'holden', label:'Holden Commodore', lcSize:null, type:'electric', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5 },
    { sku:'HDPT5', name:'Landcruiser LC5 Hub, 10" Parallel Electric', studs:5, pcd:'5/150', cc:'88.17mm', make:'lc', label:'Landcruiser LC5', lcSize:5, type:'parallel_electric', bk:'PB', cap:'GRSCAP2.5', nutSku:'490451SP', nutThread:'9/16"', nutQty:5 },
    { sku:'HT6', name:'Landcruiser LC6 Hub', studs:6, pcd:'6/139.7', cc:'69.85mm', make:'lc', label:'Landcruiser LC6', lcSize:6, type:'lazy', bk:'AB', cap:'GRSCAP2', nutSku:'WN1/2', nutThread:'1/2"', nutQty:6 },
    { sku:'HPT6', name:'Landcruiser LC6 Parallel Lazy Hub', studs:6, pcd:'6/139.7', cc:'69.85mm', make:'lc', label:'Landcruiser LC6', lcSize:6, type:'parallel_lazy', bk:'PB', cap:'GRSCAP2.5', nutSku:'WN1/2', nutThread:'1/2"', nutQty:6 },
    { sku:'422300T6', name:'Landcruiser LC6 Hub, 9" Hydraulic Drum', studs:6, pcd:'6/139.7', cc:'69.85mm', make:'lc', label:'Landcruiser LC6', lcSize:6, type:'hydraulic', bk:'AB', cap:'GRSCAP2', nutSku:'WN1/2', nutThread:'1/2"', nutQty:6 },
    { sku:'428300T6', name:'Landcruiser LC6 Hub, 10" Electric Drum', studs:6, pcd:'6/139.7', cc:'69.85mm', make:'lc', label:'Landcruiser LC6', lcSize:6, type:'electric', bk:'AB', cap:'GRSCAP2', nutSku:'WN1/2', nutThread:'1/2"', nutQty:6 },
    { sku:'HDPT6', name:'Landcruiser LC6 Hub, 10" Parallel Electric', studs:6, pcd:'6/139.7', cc:'69.85mm', make:'lc', label:'Landcruiser LC6', lcSize:6, type:'parallel_electric', bk:'PB', cap:'GRSCAP2.5', nutSku:'WN1/2', nutThread:'1/2"', nutQty:6 },
    { sku:'MHD12TL6-2T', name:'Landcruiser LC6 Hub, 12" Electric — 2T', studs:6, pcd:'6/139.7', cc:'69.85mm', make:'lc', label:'Landcruiser LC6', lcSize:6, type:'electric_12', bk:'2TE-LC6', cap:'DC62', nutSku:'WN1/2', nutThread:'1/2"', nutQty:6 },
    { sku:'MHD12TL6-3T', name:'Landcruiser LC6 Hub, 12" Electric — 3T', studs:6, pcd:'6/139.7', cc:'69.85mm', make:'lc', label:'Landcruiser LC6', lcSize:6, type:'electric_12', bk:'3TF-LC6', cap:'GC3', nutSku:'WN1/2', nutThread:'1/2"', nutQty:6 },
    { sku:'SADT5', name:'Holden HT Disc Hub & Nuts', studs:5, pcd:'5/107.95', cc:'63.45mm', make:'holden', label:'Holden HT', lcSize:null, type:'disc', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5, disc:true },
    { sku:'SADF5', name:'Ford Disc Hub & Nuts', studs:5, pcd:'5/114.3', cc:'67.18mm', make:'ford', label:'Ford', lcSize:null, type:'disc', bk:'AB', cap:'GRSCAP2', nutSku:'WN1/2', nutThread:'1/2"', nutQty:5, disc:true },
    { sku:'HUBDISC2', name:'Holden HQ Disc Rotor', studs:5, pcd:'5/120.65', cc:'70.91mm', make:'holden', label:'Holden HQ', lcSize:null, type:'disc', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5, disc:true },
    { sku:'HUBDISC120', name:'Holden Commodore Disc Rotor', studs:5, pcd:'5/120', cc:'70.53mm', make:'holden', label:'Holden Commodore', lcSize:null, type:'disc', bk:'AB', cap:'GRSCAP2', nutSku:'WN7/16', nutThread:'7/16"', nutQty:5, disc:true },
  ];

  const BK = {
    A:  { sku:'LMA1SPK',  name:'NSK (A) Bearing & Seal Kit',          marSku:'LMA1SMPK', marName:'NSK (A) Bearing & Seal Kit — Marine', innerCone:'LM67048', innerCup:'LM67010', outerCone:'LM11949', outerCup:'LM11910' },
    B:  { sku:'LMBSPK',   name:'NSK (B) Bearing & Seal Kit',          marSku:'LMBSMPK',  marName:'NSK (B) Bearing & Seal Kit — Marine', innerCone:'L68149',  innerCup:'L68110',  outerCone:'LM12749', outerCup:'LM12710' },
    PB: { sku:'LMPSPK',   name:'NSK (PB) Bearing & Seal Kit',         marSku:null,       innerCone:'L68149',  innerCup:'L68110',  outerCone:'L68149',  outerCup:'L68110' },
  };
  const IK = {
    '2TE-LC6': { sku:'2TE-LC6', name:'2T Bearing & Seal Kit — LC6', inner:'25580', innerCup:'25520', outer:'15123', outerCup:'15245' },
    '3TF-LC6': { sku:'3TF-LC6', name:'3T Bearing & Seal Kit — LC6', inner:'30210', innerCup:'30210', outer:'29749', outerCup:'29710' },
  };
  const CAPS = {
    'GRSCAP2':   { sku:'GRSCAP2',   name:'Dust Cap 1-3/4"' },
    'GRSCAP2.5': { sku:'GRSCAP2.5', name:'Dust Cap 2-1/2"' },
    'DC62':      { sku:'DC62',      name:'Dust Cap 62mm' },
    'GC3':       { sku:'GC3',       name:'Dust Cap 3" (76.5mm)' },
  };
  const NUTS = {
    'WN1/2':    { sku:'WN1/2',    name:'Wheel Nut 1/2"' },
    'WN7/16':   { sku:'WN7/16',   name:'Wheel Nut 7/16"' },
    '490451SP': { sku:'490451SP', name:'Wheel Nut 9/16"' },
  };
  const UPSELL_UNIVERSAL = [
    { id:'up-0707',      sku:'0707.82',    name:'Valvoline EP Grease 450g Tube',             type:'Upsell' },
    { id:'up-CSMD',      sku:'CSMD',       name:'Cotton Rag Bag 10kg',                        type:'Upsell' },
    { id:'up-AC400',     sku:'K/AC51/400G',name:'Koala Auto Kare Brake Cleaner 400ml',        type:'Upsell' },
    { id:'up-AC20',      sku:'K/AC55/20',  name:'Koala Auto Kare Brake Cleaner 20L',          type:'Upsell' },
  ];
  const UPSELL_AB = [
    { id:'up-630020',    sku:'630020',     name:'AL-KO Bearing Protectors (Pair)',             type:'Upsell' },
    { id:'up-1781',      sku:'1781',       name:'Genuine Bearing Buddy (Pair)',                type:'Upsell' },
  ];

  const MAKE_LINGO = {
    ford:   ['ford'],
    holden: ['holden','commodore','gemini'],
    lc:     ['landcruiser','land cruiser','lc6','lc5',' lc '],
    mini:   ['mini'],
    datsun: ['datsun'],
  };
  const MN = { ford:'Ford', holden:'Holden', lc:'Landcruiser', mini:'Mini', datsun:'Toyota/Datsun' };

  // ─── State ───────────────────────────────────────────────────────────────────
  let added = {};
  let crumbs = [];
  let scrollY = 0;

  // ─── Helpers ─────────────────────────────────────────────────────────────────
  function $id(id) { return document.getElementById(id); }
  function stage(html) {
    $id('psf-stage').innerHTML = html;
    // Every render funnels through here, so verify live stock from ONE place
    // rather than remembering to call it at each of the ~9 render sites. Any
    // path that paints result rows — keyword, SKU-exact "Found it", battery,
    // and the "In case you need it" upsell — gets its buttons checked.
    psfVerifyRendered();
  }
  function bkDetail(bk) {
    return `Inner Bearing — Cone: ${bk.innerCone} · Cup: ${bk.innerCup}<br>Outer Bearing — Cone: ${bk.outerCone} · Cup: ${bk.outerCup}`;
  }
  function ikDetail(ik) {
    return `Inner Bearing — Cone: ${ik.inner} · Cup: ${ik.innerCup}<br>Outer Bearing — Cone: ${ik.outer} · Cup: ${ik.outerCup}`;
  }
  function hubDetail(hub) {
    return `${hub.studs}-Stud · ${hub.cc} Center-to-Center · ${hub.pcd} PCD`;
  }
  function setCrumb() {
    var el = $id('psf-crumb'); if (!el) return;
    if (!crumbs.length) { el.innerHTML = ''; return; }
    el.innerHTML = '<button class="psf-bc-home" id="psf-bc-home">Search</button>' +
      crumbs.map(function (c, i) {
        // A crumb is either a plain string (normal step) or { label, pathway:true }
        // for a pathway-origin crumb, which renders the term yellow with a muted
        // "(pathway found)" note — signalling the finder recognised the term.
        var isPathway = c && typeof c === 'object' && c.pathway;
        var text = isPathway ? c.label : c;
        var cls = 'psf-bc' + (i === crumbs.length - 1 ? ' psf-bc-last' : '') + (isPathway ? ' psf-bc-pathway' : '');
        var note = isPathway ? ' <span class="psf-bc-note">(pathway found)</span>' : '';
        // After the pathway origin crumb, emit a break element. It's zero-width on
        // desktop (one continuous line) but forces a flex line-break on mobile, so
        // the origin sits on line 1 and the step crumbs wrap to line 2.
        var brk = isPathway ? '<span class="psf-bc-break"></span>' : '';
        return '<span class="psf-bc-sep">\u203A</span><span class="' + cls + '">' + text + '</span>' + note + brk;
      }).join('');
    var home = $id('psf-bc-home'); if (home) home.addEventListener('click', restart);
  }

  // ─── Cart ────────────────────────────────────────────────────────────────────
  function addToCart(skus, btn) {
    const items = skus
      .map(sku => VARIANT_IDS[sku] ? { id: VARIANT_IDS[sku], quantity: 1 } : null)
      .filter(Boolean);
    if (!items.length) return;

    // First add — the real cart add
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    })
    .then(r => r.json())
    .then(() => {
      if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('psf-done'); }

      // Update cart bubble count
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(el => {
            el.textContent = cart.item_count;
          });
          document.querySelectorAll('.cart-count-bubble span:not([aria-hidden])').forEach(el => {
            el.textContent = cart.item_count + ' items';
          });
        });

      // Update Dawn sections via cart.js — no second add, avoids double quantity
      fetch('/cart.js?sections=cart-notification-product,cart-icon-bubble')
      .then(r => r.json())
      .then(data => {
        // Inject Dawn section renders
        if (data.sections) {
          if (data.sections['cart-notification-product']) {
            const el = document.getElementById('cart-notification-product');
            if (el) el.innerHTML = data.sections['cart-notification-product'];
          }
          if (data.sections['cart-icon-bubble']) {
            const el = document.getElementById('cart-icon-bubble');
            if (el) el.innerHTML = data.sections['cart-icon-bubble'];
          }
        }
        // Open notification modal
        const notification = document.getElementById('cart-notification');
        if (notification) {
          notification.classList.add('active');
          setTimeout(() => notification.classList.remove('active'), 4000);
        }
      });
    })
    .catch(() => {
      if (btn) btn.textContent = 'Error — try again';
    });
  }

  // ─── Kit row renderer ────────────────────────────────────────────────────────
  function row(item) {
    var isDone = added[item.id];
    var p = (CODE_MAP) ? (CODE_MAP[normCode(item.sku)] || {}).product : null;
    var tile = (p && p.image)
      ? '<img class="psf-photo" src="' + psfEsc(psfImg(p.image)) + '" alt="" loading="lazy">'
      : '<img class="psf-wm" src="' + PSF_WM + '" alt="" loading="lazy">';
    var top = '<span class="psf-card-sku">' + psfEsc(item.sku) + '</span>';
    if (p && p.freight) top += '<span class="psf-card-dot">\u2022</span><span class="psf-freight">Freight Quote Req.</span>';
    else if (p && p.vendor) top += '<span class="psf-card-dot">\u2022</span><span class="psf-card-vendor">' + psfEsc(p.vendor) + '</span>';
    if (item.qty > 1) top += '<span class="psf-kit-qty">\u00d7' + item.qty + '</span>';
    if (item.marine) top += '<span class="psf-freight">Marine Seal</span>';
    var price = (p && p.price) ? '<div class="psf-card-price"><b>$' + psfEsc(p.price) + '</b></div>' : '';
    // variant size strip — show up to 4, then +N. Gated at 2+: a lone size is an
    // orphan (and single-variant "Default Title" products carry none anyway).
    // Reads p.sizes from the index; absent on an un-rebuilt index → strip just omitted.
    var sizesHtml = '';
    if (p && p.sizes && p.sizes.length > 1) {
      var shownSizes = p.sizes.slice(0, 4);
      var extraSizes = p.sizes.length - shownSizes.length;
      var chips = '';
      for (var si = 0; si < shownSizes.length; si++) {
        chips += '<span class="psf-card-size">' + psfEsc(shownSizes[si]) + '</span>';
      }
      if (extraSizes > 0) chips += '<span class="psf-card-size psf-card-size--more">+' + extraSizes + '</span>';
      sizesHtml = '<div class="psf-card-sizes">' + chips + '</div>';
    }
    var addBtn = '<button class="psf-add' + (isDone ? ' psf-done' : '') + '" id="add-' + item.id + '" data-sku="' + psfEsc(item.sku) + '">' + (isDone ? 'Added \u2713' : '+ Add') + '</button>';
    var inner = '<div class="psf-card-tile">' + tile + '</div>' +
      '<div class="psf-card-main"><div class="psf-card-top">' + top + '</div>' +
      '<div class="psf-card-title">' + psfEsc(item.name) + '</div>' + sizesHtml + '</div>' +
      '<div class="psf-card-right">' + price + addBtn + '</div>';
    // tappable through to the product page when we can resolve the handle
    return (p && p.handle)
      ? '<a href="/products/' + psfEsc(p.handle) + '" class="psf-card">' + inner + '</a>'
      : '<div class="psf-card">' + inner + '</div>';
  }

  function bindKit(items) {
    items.forEach(item => {
      const btn = $id('add-' + item.id);
      if (!btn) return;
      if (added[item.id]) { btn.textContent = 'Added ✓'; btn.classList.add('psf-done'); }
      btn.addEventListener('click', function () {
        added[item.id] = true;
        addToCart([item.sku], this);
      });
    });
    const full = $id('psf-add-full');
    if (full) {
      var kitTotal = items.reduce(function (s, i) { var pp = (CODE_MAP) ? (CODE_MAP[normCode(i.sku)] || {}).product : null; return s + (pp && pp.price ? parseFloat(pp.price) * (i.qty || 1) : 0); }, 0);
      if (kitTotal > 0) full.textContent = 'Add full kit \u2014 $' + kitTotal.toFixed(2);
      full.addEventListener('click', function () {
        items.forEach(i => {
          added[i.id] = true;
          const b = $id('add-' + i.id);
          if (b) { b.textContent = 'Added ✓'; b.classList.add('psf-done'); }
        });
        addToCart(items.map(i => i.sku), this);
        this.textContent = 'Full Kit Added ✓';
        this.classList.add('psf-done');
      });
    }
  }

  // ─── Upsells ─────────────────────────────────────────────────────────────────
  function appendUpsells(bkType, capItem, bearingOnly) {
    const s = $id('psf-stage');
    const needItItems = [];
    if (capItem) needItItems.push(capItem);
    if (bearingOnly) {
      const isAB = bkType === 'A' || bkType === 'B';
      const isInt = bkType === '2TE-LC6' || bkType === '3TF-LC6';
      if (isAB) {
        const bk = BK[bkType];
        needItItems.push({ id: 'up-kit-' + bk.sku, sku: bk.sku, name: bk.name + ' — Includes Seals', type: 'Bearing & Seal Kit', detail: bkDetail(bk) });
      } else if (isInt) {
        const ik = IK[bkType];
        needItItems.push({ id: 'up-kit-' + ik.sku, sku: ik.sku, name: ik.name, type: 'Bearing & Seal Kit', detail: ikDetail(ik) });
      } else if (bkType === 'PB') {
        const bk = BK.PB;
        needItItems.push({ id: 'up-kit-' + bk.sku, sku: bk.sku, name: bk.name, type: 'Bearing & Seal Kit', detail: bkDetail(bk) });
      }
    }
    const whileItems = [...UPSELL_UNIVERSAL];
    if (bkType === 'A' || bkType === 'B') whileItems.push(...UPSELL_AB);

    if (needItItems.length) {
      const d = document.createElement('div');
      d.innerHTML = `<div class="psf-upsell-hdr">In Case You Need It</div><div class="psf-kit-card">${needItItems.map(row).join('')}</div>`;
      s.appendChild(d);
      bindKit(needItItems);
    }
    const d2 = document.createElement('div');
    d2.innerHTML = `<div class="psf-upsell-hdr">In case you need it</div><div class="psf-kit-card">${whileItems.map(row).join('')}</div>`;
    s.appendChild(d2);
    bindKit(whileItems);

    const rs = document.createElement('span');
    rs.className = 'psf-restart';
    rs.textContent = 'Start Over';
    rs.addEventListener('click', restart);
    s.appendChild(rs);
  }

  // ─── Bearing result ───────────────────────────────────────────────────────────
  function showBearingResult(bkType, isInt, bearingOnly, knownHub) {
    const items = [];
    if (bearingOnly) {
      if (isInt) {
        const ik = IK[bkType];
        items.push({ id: 'bear-' + ik.sku, sku: ik.sku, name: ik.name.replace(' & Seal', ''), type: 'Bearings', qty: 1, detail: ikDetail(ik) });
      } else {
        const bk = BK[bkType];
        items.push({ id: 'bear-' + bk.sku, sku: bk.sku, name: bk.name.replace(' & Seal', ''), type: 'Bearings', qty: 1, detail: bkDetail(bk) });
      }
    } else {
      if (isInt) {
        const ik = IK[bkType];
        items.push({ id: 'bk-' + ik.sku, sku: ik.sku, name: ik.name, type: 'Bearings & Seal', qty: 1, detail: ikDetail(ik) });
      } else {
        const bk = BK[bkType];
        items.push({ id: 'bk-std-' + bk.sku, sku: bk.sku, name: bk.name, type: 'Bearings & Seal', qty: 1, detail: bkDetail(bk) });
        if (bk.marSku) items.push({ id: 'bk-mar-' + bk.marSku, sku: bk.marSku, name: bk.marName, type: 'Bearings & Seal (Marine)', qty: 1, detail: bkDetail(bk), marine: true });
      }
    }
    stage(`
      <div class="psf-kit-card">
        <div class="psf-kit-hdr"><span class="psf-kit-hdr-title">${bearingOnly ? 'Bearing Match' : 'Bearing & Seal Kit'}</span><span class="psf-badge psf-badge-red">${items.length} Item${items.length !== 1 ? 's' : ''}</span></div>
        ${items.map(row).join('')}
      </div>
      <button class="psf-ghost" id="psf-esc-hub">Need The Full Hub Kit? →</button>
    `);
    bindKit(items);
    $id('psf-esc-hub').addEventListener('click', () => { crumbs = []; setCrumb(); stage(''); $id('psf-input').value = 'hub'; doHubSearch(null, null); });
    let capItem = null;
    if (knownHub) {
      const cap = CAPS[knownHub.cap];
      if (cap) capItem = { id: 'up-cap-' + cap.sku, sku: cap.sku, name: cap.name, type: 'Dust Cap', qty: 1 };
    }
    appendUpsells(bkType, capItem, bearingOnly);
  }

  // ─── Hub kit ──────────────────────────────────────────────────────────────────
  function showKit(hub, bkType, marine, withBearings) {
    const items = [];
    items.push({ id: 'hub-' + hub.sku, sku: hub.sku, name: hub.name, type: 'Hub', qty: 1, detail: hubDetail(hub) });
    if (withBearings && bkType) {
      const isInt = bkType === '2TE-LC6' || bkType === '3TF-LC6';
      if (isInt) {
        const ik = IK[bkType];
        items.push({ id: 'bk-' + ik.sku, sku: ik.sku, name: ik.name, type: 'Bearings & Seal', qty: 1, detail: ikDetail(ik) });
      } else {
        const bk = BK[bkType];
        const useSku = marine && bk.marSku ? bk.marSku : bk.sku;
        const useName = marine && bk.marName ? bk.marName : bk.name;
        items.push({ id: 'bk-' + useSku, sku: useSku, name: useName, type: 'Bearings & Seal', qty: 1, detail: bkDetail(bk), marine: marine && !!bk.marSku });
      }
      const cap = CAPS[hub.cap];
      if (cap) items.push({ id: 'cap-' + cap.sku, sku: cap.sku, name: cap.name, type: 'Dust Cap', qty: 1 });
      const nut = NUTS[hub.nutSku];
      if (nut) items.push({ id: 'nut-' + hub.nutSku + hub.nutQty, sku: nut.sku, name: nut.name, type: 'Wheel Nuts', qty: hub.nutQty, detail: `${hub.nutThread} × ${hub.nutQty}` });
    }
    const marineBadge = marine ? '<span class="psf-badge psf-badge-blue">Marine Seal</span>' : '';
    stage(`
      <div class="psf-kit-card">
        <div class="psf-kit-hdr">
          <span class="psf-kit-hdr-title">${withBearings ? 'Full Kit' : 'Hub Only'}</span>
          <span class="psf-badge psf-badge-red">${items.length} Item${items.length !== 1 ? 's' : ''}</span>
          ${marineBadge}
        </div>
        ${items.map(row).join('')}
      </div>
      ${hub.note ? `<div class="psf-qn" style="margin-bottom:12px">Note: ${hub.note}</div>` : ''}
      ${withBearings ? `<button class="psf-btn-red" id="psf-add-full">Add Full Kit To Cart</button>` : ''}
      ${!withBearings ? `<button class="psf-ghost" id="psf-esc-full">Build The Full Kit →</button>` : ''}
      <div class="psf-divider"></div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    bindKit(items);
    if (!withBearings) $id('psf-esc-full').addEventListener('click', () => { crumbs.pop(); onHubResolved(hub); });
    $id('psf-rs').addEventListener('click', restart);
  }

  function showKitWithMarineNote(hub, bkType) {
    const bk = BK[bkType];
    const cap = CAPS[hub.cap];
    const nut = NUTS[hub.nutSku];
    const items = [
      { id: 'hub-' + hub.sku, sku: hub.sku, name: hub.name, type: 'Hub', qty: 1, detail: hubDetail(hub) },
      { id: 'bk-std-' + bk.sku, sku: bk.sku, name: bk.name, type: 'Bearings & Seal', qty: 1, detail: bkDetail(bk) },
    ];
    if (cap) items.push({ id: 'cap-' + cap.sku, sku: cap.sku, name: cap.name, type: 'Dust Cap', qty: 1 });
    if (nut) items.push({ id: 'nut-' + nut.sku + hub.nutQty, sku: nut.sku, name: nut.name, type: 'Wheel Nuts', qty: hub.nutQty, detail: `${hub.nutThread} × ${hub.nutQty}` });
    stage(`
      <div class="psf-kit-card">
        <div class="psf-kit-hdr"><span class="psf-kit-hdr-title">Full Kit</span><span class="psf-badge psf-badge-red">${items.length} Items</span></div>
        ${items.map(row).join('')}
      </div>
      ${bk.marSku ? `<div class="psf-mar-note">
        <div class="psf-mar-note-info">
          <div class="psf-mar-note-label">Boat Trailer? Swap Bearings For Marine-Grade:</div>
          <div class="psf-mar-note-name">${bk.marName}</div>
          <div class="psf-mar-note-sku">${bk.marSku}</div>
        </div>
        <button class="psf-add-btn" id="add-marine-swap" data-sku="${bk.marSku}">Add</button>
      </div>` : ''}
      <button class="psf-btn-red" id="psf-add-full">Add Full Kit To Cart</button>
      <div class="psf-divider"></div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    bindKit(items);
    if (bk.marSku) {
      $id('add-marine-swap').addEventListener('click', function () {
        added['marine-swap-' + bk.marSku] = true;
        addToCart([bk.marSku], this);
      });
    }
    $id('psf-rs').addEventListener('click', restart);
  }

  // ─── Bearing type questions ───────────────────────────────────────────────────
  function askBearingForBearingPath(hub, bearingOnly) {
    if (hub.bk === 'PB') { showBearingResult('PB', false, bearingOnly, hub); return; }
    if (hub.bk === '2TE-LC6' || hub.bk === '3TF-LC6') { showBearingResult(hub.bk, true, bearingOnly, hub); return; }
    const a = BK.A, b = BK.B;
    stage(`
      <div class="psf-q">Which Bearing Type?</div>
      <div class="psf-qn">Check The Number On Your Inner Bearing Cone.</div>
      <div class="psf-opts">
        <div class="psf-opt" id="bk-a">NSK (A) <span class="psf-sub">Inner Bearing Cone: ${a.innerCone}</span></div>
        <div class="psf-opt" id="bk-b">NSK (B) <span class="psf-sub">Inner Bearing Cone: ${b.innerCone}</span></div>
        <div class="psf-opt psf-opt-muted" id="bk-ns">Not Sure — Use NSK (A) <span class="psf-sub">Most Common</span></div>
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    $id('bk-a').addEventListener('click', () => { crumbs.push('NSK (A)'); setCrumb(); showBearingResult('A', false, bearingOnly, hub); });
    $id('bk-b').addEventListener('click', () => { crumbs.push('NSK (B)'); setCrumb(); showBearingResult('B', false, bearingOnly, hub); });
    $id('bk-ns').addEventListener('click', () => { crumbs.push('NSK (A) — Not Sure'); setCrumb(); showBearingResult('A', false, bearingOnly, hub); });
    $id('psf-rs').addEventListener('click', restart);
  }

  function askBearing(hub) {
    if (hub.bk === 'PB') { askMarine(hub, 'PB'); return; }
    if (hub.bk === '2TE-LC6' || hub.bk === '3TF-LC6') { showKit(hub, hub.bk, false, true); return; }
    const a = BK.A, b = BK.B;
    stage(`
      <div class="psf-q">Which Bearing Type?</div>
      <div class="psf-qn">Check The Number On Your Inner Bearing Cone — The Tapered Roller Bearing Closest To The Centre Of The Axle.</div>
      <div class="psf-opts">
        <div class="psf-opt" id="bk-a">NSK (A) <span class="psf-sub">Inner Bearing Cone: ${a.innerCone}</span></div>
        <div class="psf-opt" id="bk-b">NSK (B) <span class="psf-sub">Inner Bearing Cone: ${b.innerCone}</span></div>
        <div class="psf-opt psf-opt-muted" id="bk-ns">Not Sure — Use NSK (A) <span class="psf-sub">Most Common · Marine Option Shown In Kit</span></div>
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    $id('bk-a').addEventListener('click', () => { crumbs.push('NSK (A)'); setCrumb(); askMarine(hub, 'A'); });
    $id('bk-b').addEventListener('click', () => { crumbs.push('NSK (B)'); setCrumb(); askMarine(hub, 'B'); });
    $id('bk-ns').addEventListener('click', () => { crumbs.push('NSK (A) — Not Sure'); setCrumb(); showKitWithMarineNote(hub, 'A'); });
    $id('psf-rs').addEventListener('click', restart);
  }

  function askMarine(hub, bkType) {
    if (bkType === 'PB' || !BK[bkType] || !BK[bkType].marSku) { showKit(hub, bkType, false, true); return; }
    const bk = BK[bkType];
    stage(`
      <div class="psf-q">Boat Trailer?</div>
      <div class="psf-qn">Marine-grade seals recommended for trailers that go in water.</div>
      <div class="psf-opts">
        <div class="psf-opt" id="mar-y">Yes — Boat Trailer <span class="psf-sub">${bk.marSku}</span></div>
        <div class="psf-opt" id="mar-n">No — Standard Trailer <span class="psf-sub">${bk.sku}</span></div>
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    $id('mar-y').addEventListener('click', () => { crumbs.push('Marine'); setCrumb(); showKit(hub, bkType, true, true); });
    $id('mar-n').addEventListener('click', () => { showKit(hub, bkType, false, true); });
    $id('psf-rs').addEventListener('click', restart);
  }

  function askBearingDisc(hub) {
    const a = BK.A, b = BK.B;
    stage(`
      <div class="psf-q">Which Bearing Type?</div>
      <div class="psf-qn">Disc Hubs Use Marine-Grade Seals Automatically. Check Your Inner Bearing Cone.</div>
      <div class="psf-opts">
        <div class="psf-opt" id="bk-a">NSK (A) <span class="psf-sub">Inner Bearing Cone: ${a.innerCone}</span></div>
        <div class="psf-opt" id="bk-b">NSK (B) <span class="psf-sub">Inner Bearing Cone: ${b.innerCone}</span></div>
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    $id('bk-a').addEventListener('click', () => { crumbs.push('NSK (A)'); setCrumb(); showKit(hub, 'A', true, true); appendCaliperQ(); });
    $id('bk-b').addEventListener('click', () => { crumbs.push('NSK (B)'); setCrumb(); showKit(hub, 'B', true, true); appendCaliperQ(); });
    $id('psf-rs').addEventListener('click', restart);
  }

  // ─── Caliper flow ─────────────────────────────────────────────────────────────
  function appendCaliperQ() {
    const s = $id('psf-stage');
    const d = document.createElement('div');
    d.innerHTML = `<div class="psf-divider"></div><div class="psf-q">Need A Brake Caliper?</div>
      <div class="psf-opts"><div class="psf-opt" id="cal-no">No</div><div class="psf-opt" id="cal-yes">Yes</div></div>`;
    s.appendChild(d);
    $id('cal-no').addEventListener('click', () => d.remove());
    $id('cal-yes').addEventListener('click', () => { d.remove(); showCaliperFlow(); });
  }

  function showCaliperFlow() {
    const s = $id('psf-stage');
    const d = document.createElement('div');
    d.innerHTML = `<div class="psf-q">Complete Caliper Or Components?</div>
      <div class="psf-opts">
        <div class="psf-opt" id="cal-full">Complete Caliper <span class="psf-sub">323300 — Includes Pads, T-Block, Anti-Rattle</span></div>
        <div class="psf-opt" id="cal-parts">Individual Components</div>
      </div>`;
    s.appendChild(d);
    $id('cal-full').addEventListener('click', () => {
      d.remove();
      const items = [{ id: 'cal-323300', sku: '323300', name: 'AL-KO Mechanical Brake Caliper (Complete)', type: 'Caliper', qty: 1, detail: 'Includes T-Block, Pads, Anti-Rattle Clips' }];
      const dd = document.createElement('div');
      dd.innerHTML = `<div class="psf-kit-card"><div class="psf-kit-hdr"><span class="psf-kit-hdr-title">Caliper</span></div>${items.map(row).join('')}</div>`;
      $id('psf-stage').appendChild(dd);
      bindKit(items);
    });
    $id('cal-parts').addEventListener('click', () => { d.remove(); showCaliperParts(); });
  }

  function showCaliperParts() {
    const PARTS = [
      { id:'cp-323316', sku:'323316', label:'Anti-Rattle Clip', type:'Caliper Component' },
      { id:'cp-323114', sku:'323114', label:'T-Block', type:'Caliper Component' },
      { id:'cp-BFWG03', sku:'BFWG03', label:'Cable Clamp (Individual)', type:'Caliper Component' },
      { id:'cp-ADJ', sku:'BRKCABL-ADJ-HD', label:'Heavy Duty Cable Adjuster', type:'Caliper Component' },
    ];
    const s = $id('psf-stage');
    const d = document.createElement('div');
    d.innerHTML = `<div class="psf-q" style="margin-bottom:10px">Select Components:</div>
      <div class="psf-opts">
        ${PARTS.map(p => `<div class="psf-opt psf-cp" data-id="${p.id}" data-sku="${p.sku}" data-label="${p.label}" data-type="${p.type}">${p.label} <span class="psf-sub">${p.sku}</span></div>`).join('')}
        <div class="psf-opt" id="pads-t">Brake Pads →</div>
        <div class="psf-opt" id="cable-t">Brake Cable Kit →</div>
      </div>
      <div id="pads-sub" style="display:none;padding:12px;background:#1a1816;border:1px solid rgba(240,236,230,.07);margin-bottom:6px">
        <div class="psf-qn">Early Model (Up To 2016 Caliper) Or Late Model?</div>
        <div class="psf-opts">
          <div class="psf-opt psf-cp" data-id="cp-349100" data-sku="349100" data-label="Brake Pads — Early Model" data-type="Brake Pads">Early Model <span class="psf-sub">349100</span></div>
          <div class="psf-opt psf-cp" data-id="cp-323315" data-sku="323315" data-label="Brake Pads — Late Model (2016 On)" data-type="Brake Pads">Late Model, 2016 On <span class="psf-sub">323315</span></div>
        </div>
      </div>
      <div id="cable-sub" style="display:none;padding:12px;background:#1a1816;border:1px solid rgba(240,236,230,.07);margin-bottom:6px">
        <div class="psf-qn">Standard Or Stainless?</div>
        <div class="psf-opts">
          <div class="psf-opt psf-cp" data-id="cp-hdset" data-sku="BRKCABL-HDSET" data-label="Standard Brake Cable Kit" data-type="Brake Cable">Standard <span class="psf-sub">BRKCABL-HDSET</span></div>
          <div class="psf-opt psf-cp" data-id="cp-ss" data-sku="BRKCABLHD-KIT-SS" data-label="Stainless Steel Brake Cable Kit" data-type="Brake Cable">Stainless Steel <span class="psf-sub">BRKCABLHD-KIT-SS</span></div>
        </div>
      </div>
      <div id="cp-added"></div>`;
    s.appendChild(d);
    $id('pads-t').addEventListener('click', () => { const el = $id('pads-sub'); el.style.display = el.style.display === 'none' ? 'block' : 'none'; });
    $id('cable-t').addEventListener('click', () => { const el = $id('cable-sub'); el.style.display = el.style.display === 'none' ? 'block' : 'none'; });
    d.querySelectorAll('.psf-cp').forEach(el => {
      el.addEventListener('click', function () {
        const { id, sku, label } = this.dataset;
        if (added[id]) return;
        added[id] = true;
        this.style.borderColor = 'rgba(255,213,37,.25)';
        this.style.color = 'rgba(240,236,230,.4)';
        const r = document.createElement('div');
        r.style.cssText = 'background:#1e1c1a;border:1px solid rgba(240,236,230,.07);padding:10px 14px;margin-bottom:5px;display:flex;justify-content:space-between;font-size:13px';
        r.innerHTML = `<span>${label}</span><span style="color:#ffd525;font-family:monospace">${sku}</span>`;
        $id('cp-added').appendChild(r);
        addToCart([sku], null);
      });
    });
  }

  // ─── 12" LC6 ─────────────────────────────────────────────────────────────────
  function show12LC() {
    const h2 = H.find(h => h.sku === 'MHD12TL6-2T');
    const h3 = H.find(h => h.sku === 'MHD12TL6-3T');
    stage(`
      <div class="psf-q">12" LC6 — Check Your Inner Bearing</div>
      <div class="psf-qn">These Hubs Aren't Stamped With A Load Rating. Check The Number On Your Inner Bearing Cone.</div>
      <div class="psf-sbs">
        <div class="psf-sbs-card">
          <div class="psf-sbs-title">2T — MHD12TL6-2T</div>
          <div class="psf-sbs-race">Inner Bearing: 25580 / 25520<br>Outer Bearing: 15123 / 15245<br>Seal: MSE</div>
          <button class="psf-opt" id="pick-2t" style="width:100%;font-size:13px">This Is Mine</button>
        </div>
        <div class="psf-sbs-card">
          <div class="psf-sbs-title">3T — MHD12TL6-3T</div>
          <div class="psf-sbs-race">Inner Bearing: 30210 / 30210<br>Outer Bearing: 29749 / 29710<br>Seal: MSF</div>
          <button class="psf-opt" id="pick-3t" style="width:100%;font-size:13px">This Is Mine</button>
        </div>
      </div>
      <div class="psf-phone-box">
        <p>Not Sure Which Hub You Have? Give Us A Call — Caravan Hubs Can Be Tricky.</p>
        <strong>(08) 8725 9299</strong>
        <small>Mon–Fri 8am–5pm · Sat 9am–12pm</small>
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    $id('pick-2t').addEventListener('click', () => { crumbs.push('2T LC6'); setCrumb(); showKit(h2, '2TE-LC6', false, true); });
    $id('pick-3t').addEventListener('click', () => { crumbs.push('3T LC6'); setCrumb(); showKit(h3, '3TF-LC6', false, true); });
    $id('psf-rs').addEventListener('click', restart);
  }

  // ─── Hub resolved ─────────────────────────────────────────────────────────────
  function onHubResolved(hub, fromBearingPath, bearingOnly) {
    crumbs.push(hub.label); setCrumb();
    if (hub.type === 'electric_12') { show12LC(); return; }
    if (fromBearingPath) { askBearingForBearingPath(hub, bearingOnly || false); return; }
    stage(`
      <div class="psf-q">Hub Only, Or Full Kit?</div>
      <div class="psf-qn" style="margin-bottom:4px"><strong style="color:#f0ece6">${hub.name}</strong></div>
      <div class="psf-qn">${hubDetail(hub)}</div>
      <div class="psf-opts">
        <div class="psf-opt" id="intent-full">Full Kit <span class="psf-sub">Hub · Bearings · Dust Cap · Nuts</span></div>
        <div class="psf-opt" id="intent-hub">Hub Only</div>
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    $id('intent-full').addEventListener('click', () => { crumbs.push('Full Kit'); setCrumb(); hub.disc ? askBearingDisc(hub) : askBearing(hub); });
    $id('intent-hub').addEventListener('click', () => { showKit(hub, null, false, false); });
    $id('psf-rs').addEventListener('click', restart);
  }

  // ─── Hub tree ─────────────────────────────────────────────────────────────────
  function askType(hubs, fromBearingPath, bearingOnly) {
    const types = [...new Set(hubs.map(h => h.type))];
    if (types.length === 1) { onHubResolved(hubs[0], fromBearingPath, bearingOnly); return; }
    stage(`
      <div class="psf-q">What Type Of Hub?</div>
      <div class="psf-opts">
        ${types.map(t => `<div class="psf-opt psf-type-opt" data-type="${t}">${TYPE_LABELS[t] || t}</div>`).join('')}
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    document.querySelectorAll('.psf-type-opt').forEach(b => {
      b.addEventListener('click', function () {
        const t = this.dataset.type;
        crumbs.push(TYPE_LABELS[t]); setCrumb();
        if (t === 'electric_12') { show12LC(); return; }
        const hub = hubs.find(h => h.type === t);
        if (hub) onHubResolved(hub, fromBearingPath, bearingOnly);
      });
    });
    $id('psf-rs').addEventListener('click', restart);
  }

  function askMakeGroup(make, hubs, fromBearingPath, bearingOnly) {
    const labels = [...new Set(hubs.map(h => h.label))];
    if (labels.length === 1) { askType(hubs, fromBearingPath, bearingOnly); return; }
    stage(`
      <div class="psf-q">Which ${make === 'holden' ? 'Holden Model' : 'Landcruiser Type'}?</div>
      <div class="psf-opts">
        ${labels.map(l => {
          const s = hubs.find(h => h.label === l);
          return `<div class="psf-opt psf-lbl-opt" data-label="${l}">${l} <span class="psf-sub">${s.cc} Center-to-Center · ${s.pcd} PCD</span></div>`;
        }).join('')}
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    document.querySelectorAll('.psf-lbl-opt').forEach(b => {
      b.addEventListener('click', function () {
        crumbs.push(this.dataset.label); setCrumb();
        askType(hubs.filter(h => h.label === this.dataset.label), fromBearingPath, bearingOnly);
      });
    });
    $id('psf-rs').addEventListener('click', restart);
  }

  function askMakeFromList(hubs, fromBearingPath, bearingOnly) {
    const makes = [...new Set(hubs.map(h => h.make))];
    stage(`
      <div class="psf-q">What Vehicle?</div>
      <div class="psf-opts">
        ${makes.map(m => `<div class="psf-opt psf-mk-opt" data-make="${m}">${MN[m] || m}</div>`).join('')}
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    document.querySelectorAll('.psf-mk-opt').forEach(b => {
      b.addEventListener('click', function () {
        const m = this.dataset.make;
        crumbs.push(MN[m] || m); setCrumb();
        askMakeGroup(m, hubs.filter(h => h.make === m), fromBearingPath, bearingOnly);
      });
    });
    $id('psf-rs').addEventListener('click', restart);
  }

  function doHubSearch(detectedMake, detectedLcSize, fromBearingPath, bearingOnly) {
    let hubs = H.filter(h => !h.disc);
    if (detectedMake) hubs = hubs.filter(h => h.make === detectedMake);
    if (detectedLcSize) hubs = hubs.filter(h => h.lcSize === detectedLcSize);
    if (detectedMake) {
      if (detectedLcSize) askType(hubs, fromBearingPath, bearingOnly);
      else askMakeGroup(detectedMake, hubs, fromBearingPath, bearingOnly);
      return;
    }
    const studCounts = [...new Set(hubs.map(h => h.studs))].sort();
    stage(`
      <div class="psf-q">How Many Wheel Studs?</div>
      <div class="psf-opts">
        ${studCounts.map(s => `<div class="psf-opt psf-stud-opt" data-studs="${s}">${s} Stud</div>`).join('')}
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    document.querySelectorAll('.psf-stud-opt').forEach(b => {
      b.addEventListener('click', function () {
        const s = parseInt(this.dataset.studs);
        crumbs.push(s + '-Stud'); setCrumb();
        const filtered = hubs.filter(h => h.studs === s);
        const ms = [...new Set(filtered.map(h => h.make))];
        if (ms.length === 1) askMakeGroup(ms[0], filtered, fromBearingPath, bearingOnly);
        else askMakeFromList(filtered, fromBearingPath, bearingOnly);
      });
    });
    $id('psf-rs').addEventListener('click', restart);
  }

  // ─── Bearing entry ────────────────────────────────────────────────────────────
  function doBearingSearch() {
    stage(`
      <div class="psf-q">What Are You After?</div>
      <div class="psf-opts">
        <div class="psf-opt" id="bp-kit">Bearing & Seal Kit <span class="psf-sub">Kit With Seals — Most Common</span></div>
        <div class="psf-opt" id="bp-bearing">Bearing Only <span class="psf-sub">Individual Bearing, No Seal</span></div>
        <div class="psf-opt" id="bp-hub">Full Hub Kit <span class="psf-sub">Hub, Bearings, Dust Cap & Nuts</span></div>
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    $id('bp-kit').addEventListener('click', () => { crumbs.push('Bearing & Seal Kit'); setCrumb(); doBearingKitSearch(false); });
    $id('bp-bearing').addEventListener('click', () => { crumbs.push('Bearing Only'); setCrumb(); doBearingKitSearch(true); });
    $id('bp-hub').addEventListener('click', () => { crumbs.push('Full Hub Kit'); setCrumb(); doHubSearch(null, null, false, false); });
    $id('psf-rs').addEventListener('click', restart);
  }

  function doBearingKitSearch(bearingOnly) {
    stage(`
      <div class="psf-q">Do You Have A Bearing Number?</div>
      <div class="psf-qn">Check The Number Stamped On Your Bearing Cone Or Cup.</div>
      <div class="psf-opts">
        <div class="psf-opt" id="bn-yes">Yes — I Have A Number</div>
        <div class="psf-opt" id="bn-no">No — I Know My Hub</div>
        <div class="psf-opt" id="bn-neither">Neither</div>
      </div>
      <span class="psf-restart" id="psf-rs">Start Over</span>
    `);
    $id('bn-yes').addEventListener('click', () => {
      stage(`
        <div class="psf-q">Enter Your Bearing Number:</div>
        <div class="psf-qn">Type The Number From Your Bearing Cone Or Cup — e.g. LM67048, L68149</div>
        <div class="psf-search-input-wrap">
          <input id="psf-bn-input" placeholder="e.g. LM67048" autocomplete="off">
          <button id="psf-bn-search">Search</button>
        </div>
        <span class="psf-restart" id="psf-rs">Start Over</span>
      `);
      const doSearch = () => {
        const v = ($id('psf-bn-input') || { value: '' }).value.toLowerCase().trim();
        const raceA = ['lm67048','lm67049','lm67010','lm11949','lm11910'];
        const raceB = ['l68149','l68110','lm12749','lm12710'];
        if (raceA.some(r => v.includes(r))) { crumbs.push('NSK (A)'); setCrumb(); showBearingResult('A', false, bearingOnly, null); }
        else if (raceB.some(r => v.includes(r))) { crumbs.push('NSK (B)'); setCrumb(); showBearingResult('B', false, bearingOnly, null); }
        else {
          stage(`
            <div class="psf-qn">No Match For That Number — Double Check And Try Again.</div>
            <div class="psf-phone-box" style="margin-top:12px">
              <p>Can't Find It? Call Us Direct.</p>
              <strong>(08) 8725 9299</strong>
              <small>Mon–Fri 8am–5pm · Sat 9am–12pm</small>
            </div>
            <span class="psf-restart" id="psf-rs">Start Over</span>
          `);
          $id('psf-rs').addEventListener('click', restart);
        }
      };
      $id('psf-bn-search').addEventListener('click', doSearch);
      $id('psf-bn-input').addEventListener('keydown', e => { if (e.key === 'Enter') doSearch(); });
      $id('psf-rs').addEventListener('click', restart);
    });
    $id('bn-no').addEventListener('click', () => { crumbs.push('Know My Hub'); setCrumb(); doHubSearch(null, null, true, bearingOnly); });
    $id('bn-neither').addEventListener('click', () => {
      stage(`
        <div class="psf-phone-box">
          <p>Give Us A Call And We'll Track Down The Right Bearing.</p>
          <strong>(08) 8725 9299</strong>
          <small>Mon–Fri 8am–5pm · Sat 9am–12pm</small>
        </div>
        <span class="psf-restart" id="psf-rs">Start Over</span>
      `);
      $id('psf-rs').addEventListener('click', restart);
    });
    $id('psf-rs').addEventListener('click', restart);
  }

  // ─── Jockey wheel pathway ─────────────────────────────────────────────────────
  // Three filters, not a drill to one: size -> type -> mount. Each step asks a
  // question ONLY while more than one value survives; a question with a single
  // value left (or blank, e.g. removable units carry no mount) is skipped. The
  // surviving set is the answer and renders through the shared card, so live
  // stock, freight pill and image-fit come for free via stage().
  var JW_STEPS = [
    { key: 'jockey_size', q: 'What Size Wheel?',
      opts: [ ['6', '6"'], ['8', '8"'], ['10', '10"'] ] },
    { key: 'jockey_type', q: 'What Type?',
      opts: [ ['swing_up', 'Swing-Up <span class="psf-sub">Pivots Up And Pins For Travel</span>'],
              ['removable', 'Removable <span class="psf-sub">Sits In A Clamp, Lifts Out</span>'] ] },
    { key: 'jockey_mount', q: 'How Does It Mount?',
      opts: [ ['weld_on', 'Weld-On'], ['u_bolt', 'U-Bolt Bracket'] ] }
  ];
  var JW_NOUN = 'jockey wheels';   // plural noun for the "Show all N …" escape hatch

  // Full pathway set, cached on first load so the show-all hatch and every
  // question step share one fetch. jwStep/jwAsk read from this via doJockeyWheel.
  var jwFull = null;

  function jwPool(cb) {
    if (jwFull) { cb(jwFull); return; }
    loadIndexData(function (data) {
      if (!data) { cb(null); return; }
      jwFull = (data.products || []).filter(function (p) { return p.part_type === 'jockey_wheel'; });
      cb(jwFull);
    });
  }

  function doJockeyWheel() {
    stage('<div class="psf-qn" style="color:rgba(240,236,230,0.4)">Loading jockey wheels...</div>');
    jwPool(function (pool) {
      if (!pool || !pool.length) { resolveViaIndex('jockey wheel', 'jockey wheel'); return; }
      jwStep(pool, 0);
    });
  }

  // The persistent escape hatch. Rendered under every question step: drops the
  // customer out of the guided flow into the full pathway set (NOT a keyword
  // search — the curated part_type set, uncapped). Count + noun both come from
  // the pathway, so the same markup templates for any future pathway.
  function jwHatchHtml() {
    return '<div class="psf-opt psf-opt-muted psf-jw-hatch psf-jw-showall" style="justify-content:center">Show all ' +
      jwFull.length + ' ' + JW_NOUN + '</div>';
  }

  // items: surviving products. si: index into JW_STEPS to try next.
  function jwStep(items, si) {
    // Find the next step that actually splits the current pool.
    while (si < JW_STEPS.length) {
      var step = JW_STEPS[si];
      var present = {};
      items.forEach(function (p) {
        var val = (p.finder && p.finder[step.key]) || '';
        if (val) present[val] = true;
      });
      var vals = Object.keys(present);
      if (vals.length > 1) { jwAsk(items, si, step, present); return; }
      si++;   // 0 or 1 value here — nothing to ask, fall through to the next field
    }
    jwResults(items);   // no question left to narrow on — show the shelf
  }

  function jwAsk(items, si, step, present) {
    var opts = step.opts.filter(function (o) { return present[o[0]]; });
    stage(
      '<div class="psf-q">' + step.q + '</div>' +
      '<div class="psf-opts">' +
      opts.map(function (o) {
        return '<div class="psf-opt psf-jw-opt" data-val="' + o[0] + '">' + o[1] + '</div>';
      }).join('') +
      '</div>' +
      jwHatchHtml() +
      '<span class="psf-restart" id="psf-rs">Start Over</span>'
    );
    document.querySelectorAll('.psf-jw-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = this.dataset.val;
        var label = (opts.filter(function (o) { return o[0] === val; })[0][1]).replace(/<[^>]+>/g, '').trim();
        crumbs.push(label); setCrumb();
        var next = items.filter(function (p) { return (p.finder && p.finder[step.key]) === val; });
        jwStep(next, si + 1);
      });
    });
    jwBindHatch();
    $id('psf-rs').addEventListener('click', restart);
  }

  // Show the full pathway set as a flat browsable shelf. Resets the crumb to the
  // pathway origin plus an "All" step, and offers a way back into the guided flow.
  function jwShowAll() {
    crumbs = [{ label: 'Jockey Wheel', pathway: true }, 'All']; setCrumb();
    stage(
      '<div class="psf-qn">All ' + jwFull.length + ' ' + JW_NOUN + '</div>' +
      '<div class="psf-results">' + jwFull.map(indexResultRow).join('') + '</div>' +
      '<div class="psf-opt psf-opt-muted psf-jw-hatch psf-jw-guided" style="justify-content:center">\u2039 Back to guided finder</div>' +
      '<span class="psf-restart" id="psf-rs">Start Over</span>'
    );
    var g = document.querySelector('.psf-jw-guided');
    if (g) g.addEventListener('click', function () { crumbs = [{ label: 'Jockey Wheel', pathway: true }]; setCrumb(); doJockeyWheel(); });
    var rs = $id('psf-rs'); if (rs) rs.addEventListener('click', restart);
  }

  function jwBindHatch() {
    var h = document.querySelector('.psf-jw-showall');
    if (h) h.addEventListener('click', jwShowAll);
  }

  function jwResults(items) {
    // Offer the full-set hatch only when the shelf is a strict subset — no point
    // showing "Show all 17" when the result already IS all 17.
    var showHatch = items.length < jwFull.length;
    stage(
      '<div class="psf-qn">' + items.length + (items.length === 1 ? ' Match' : ' Matches') + '</div>' +
      '<div class="psf-results">' + items.map(indexResultRow).join('') + '</div>' +
      (items.length === 1 ? alsoNeededHtml(items[0]) : '') +
      (showHatch ? jwHatchHtml() : '') +
      '<span class="psf-restart" id="psf-rs">Start Over</span>'
    );
    if (showHatch) jwBindHatch();
    var rs = $id('psf-rs'); if (rs) rs.addEventListener('click', restart);
  }

  // ─── Battery data — loaded once from CDN on finder open ──────────────────────
  let batteryData = null;
  let batteryLoading = false;

  function loadBatteryData(callback) {
    if (batteryData) { callback(batteryData); return; }
    if (batteryLoading) { setTimeout(() => loadBatteryData(callback), 100); return; }
    batteryLoading = true;
    fetch('https://cdn.shopify.com/s/files/1/0874/9986/6389/files/ps-battery-fitments.json?v=1778284596')
      .then(r => r.json())
      .then(data => { batteryData = data; batteryLoading = false; callback(batteryData); })
      .catch(() => { batteryLoading = false; showBatteryPhone(); });
  }

  // ─── Finder index ─ full catalogue, loaded once on open ──────
  let indexData = null;
  let indexLoading = false;
  let CODE_MAP = null;
  // Resolved by ps-finder.liquid from Shopify Files, so replacing the file in
  // admin updates this automatically. The literal is only a fallback.
  const INDEX_URL = window.PSF_INDEX_URL || 'https://cdn.shopify.com/s/files/1/0874/9986/6389/files/ps-finder-index.json?v=1786065542';

  function normCode(s) { return (s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }

  function buildCodeMap(data) {
    const m = {};
    (data.products || []).forEach(function (p) {
      const reg = function (raw, type) { const k = normCode(raw); if (k && !m[k]) m[k] = { product: p, type: type }; };
      const c = p.codes || {};
      (c.sku || []).forEach(function (x) { reg(x, 'sku'); });
      (c.cross || []).forEach(function (x) { reg(x, 'cross-reference'); });
      (c.bearing || []).forEach(function (x) { reg(x, 'bearing number'); });
    });
    return m;
  }

  function loadIndexData(callback) {
    if (indexData) { callback(indexData); return; }
    if (indexLoading) { setTimeout(function () { loadIndexData(callback); }, 100); return; }
    indexLoading = true;
    fetch(INDEX_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) { indexData = data; CODE_MAP = buildCodeMap(data); indexLoading = false; callback(indexData); })
      .catch(function () { indexLoading = false; callback(null); });
  }

  var PSF_WM = 'https://cdn.shopify.com/s/files/1/0874/9986/6389/files/psbrands-parts-stop.webp';
  function psfIsMobile() { return window.matchMedia('(max-width:600px)').matches; }
  function psfCapTitle(t) {
    t = t || '';
    if (!psfIsMobile() || t.length <= 80) return t;
    var s = t.slice(0, 80), i = s.lastIndexOf(' ');
    if (i > 48) s = s.slice(0, i);
    return s.replace(/\s+$/, '') + '\u2026';
  }
  // The export gives absolute cdn.shopify.com urls. Those are cross-origin, which taints
  // the canvas the thumbnail-fit script samples — so the fit silently never applies and
  // products sit tiny in the tile. Shopify serves the same files from the shop's own
  // domain at /cdn/shop/files/..., so rewrite to that: same-origin, no tainting, and the
  // fit works exactly as it does on the cart. Anything that doesn't match is left alone.
  function psfImg(url) {
    if (!url) return '';
    return url.replace(/^https?:\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/(files|products)\//, '/cdn/shop/$1/');
  }

  function psfEsc(s) { return (s == null ? '' : String(s)).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  // The two action-button shapes. Kept as one function so the snapshot render and
  // the live correction can never drift apart.
  function psfActionBtn(handle, sku, inStock) {
    if (inStock) {
      return '<button class="psf-add" data-handle="' + psfEsc(handle) + '" data-sku="' + psfEsc(sku) + '">+ Add</button>';
    }
    return '<button class="psf-call" data-handle="' + psfEsc(handle) + '"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg> Call to <span class="psf-call-word">secure</span></button>';
  }

  /* ── Live stock check ──────────────────────────────────────────────────────
     The index is a snapshot rebuilt only when code changes ship, so its stock
     goes stale. The ONE thing that must be current is the Add-vs-Call button:
     showing "+ Add" on something sold out breaks the shop's on-the-shelf promise.

     After results paint from the snapshot, this fetches Shopify's live
     /products/{handle}.js (no auth, CDN-cached, live `available`) for each
     visible card and flips any button the snapshot got wrong. Everything else
     on the card stays snapshot.

     Fail-open on every path: a fetch that errors, times out or 404s leaves the
     snapshot button exactly as it was. The finder never breaks because a stock
     check didn't answer. Results are cached for the session (short TTL) so
     re-searching the same products doesn't refetch.
  ------------------------------------------------------------------------------ */
  var PSF_STOCK = {};                 // handle -> { avail: bool, at: ms }
  var PSF_STOCK_TTL = 30000;          // 30s — short so a restock shows up fast, long
                                      // enough not to refetch within a single search session

  function psfApplyStock(handle, avail) {
    var wraps = document.querySelectorAll('.psf-action[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/"/g, '\\"')) + '"]');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      // Don't stomp a button the user has already acted on (added / in-flight).
      if (w.querySelector('.psf-added') || w.querySelector('[data-busy]')) continue;
      var sku = w.getAttribute('data-sku') || '';

      // Only touch the DOM if the state actually changed. When the live check
      // agrees with the snapshot — the common case — nothing moves, so there's
      // no gratuitous flicker on every search.
      var wantAdd = !!avail;
      var hasAdd = !!w.querySelector('.psf-add');
      var isEmpty = !w.firstChild;
      if (!isEmpty && wantAdd === hasAdd) continue;

      var html = psfActionBtn(handle, sku, avail);

      // First paint, or reduced-motion: swap with no animation.
      if (isEmpty || PSF_REDUCE_MOTION) { w.innerHTML = html; continue; }

      // Cross-fade: the button is replaced wholesale (old node gone, new node in),
      // so a plain CSS transition can't ride it. Fade the wrapper out, swap at the
      // trough, fade back in. Quick — this is a settle, not a feature.
      psfFadeSwap(w, html);
    }
  }

  var PSF_REDUCE_MOTION = (window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches) || false;

  function psfFadeSwap(el, html) {
    el.style.transition = 'opacity 0.13s ease';
    el.style.opacity = '0';
    var swapped = false;
    var doSwap = function () {
      if (swapped) return; swapped = true;
      el.innerHTML = html;
      // next frame, fade back up
      requestAnimationFrame(function () { el.style.opacity = '1'; });
    };
    var once = function () { el.removeEventListener('transitionend', once); doSwap(); };
    el.addEventListener('transitionend', once);
    // Fallback if transitionend doesn't fire (element off-screen, etc.)
    setTimeout(doSwap, 180);
  }

  function psfCheckOne(handle) {
    var cached = PSF_STOCK[handle];
    if (cached && (Date.now() - cached.at) < PSF_STOCK_TTL) {
      psfApplyStock(handle, cached.avail);
      return;
    }
    // Timeout so a slow response never leaves a stale-but-visible button hanging.
    var done = false;
    var to = setTimeout(function () { done = true; }, 4000);
    // cache:'no-store' + a cache-busting param defeat the browser's own HTTP cache.
    // Without these, Chrome on iOS (WebKit) will happily serve a stale copy of the
    // product JSON from before a stock change and never hit Shopify — which is why
    // a restock showed on the product page but not in the finder on iPhone.
    var bust = '?_ps=' + Date.now();
    fetch('/products/' + encodeURIComponent(handle) + '.js' + bust, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        clearTimeout(to);
        if (done || !data) return;                       // timed out or bad response — keep snapshot
        // Single-variant catalogue: product.available === the variant's. If a
        // product ever has variants, `available` is true when ANY is sellable,
        // which is the right call for a one-card-per-product finder.
        var avail = !!data.available;
        PSF_STOCK[handle] = { avail: avail, at: Date.now() };
        psfApplyStock(handle, avail);
      })
      .catch(function () { clearTimeout(to); /* fail-open: snapshot stands */ });
  }

  // Sweep the freshly-rendered stage for stock buttons and verify each unique
  // handle live. Reads handle off the DOM, so it covers every render path with
  // no per-path wiring. Staggered so a full result set doesn't fire at once.
  function psfVerifyRendered() {
    var stageEl = $id('psf-stage');
    if (!stageEl) return;
    var wraps = stageEl.querySelectorAll('.psf-action[data-handle]');
    var seen = {}, order = [];
    for (var i = 0; i < wraps.length; i++) {
      var h = wraps[i].getAttribute('data-handle');
      if (h && !seen[h]) { seen[h] = 1; order.push(h); }
    }
    order.forEach(function (h, idx) {
      setTimeout(function () { psfCheckOne(h); }, idx * 40);
    });
  }

  // v3 result card — every index result renders through this
  function indexResultRow(p) {
    var url = '/products/' + p.handle;
    var tile = p.image
      ? '<img class="psf-photo" src="' + psfEsc(psfImg(p.image)) + '" alt="" loading="lazy">'
      : '<img class="psf-wm" src="' + PSF_WM + '" alt="" loading="lazy">';
    var second = p.freight
      ? '<span class="psf-freight">Freight Quote Req.</span>'
      : '<span class="psf-card-vendor">' + psfEsc(p.vendor) + '</span>';
    var price = p.price ? '<div class="psf-card-price"><b>$' + psfEsc(p.price) + '</b></div>' : '';
    // The action button is the ONE live element on the card. It renders from the
    // snapshot immediately, then the stage() stock sweep checks Shopify's live inventory
    // in the background and swaps it if the snapshot was wrong. The wrapper carries
    // the handle+sku so the swap can find it without re-rendering the whole card.
    var action = '<span class="psf-action" data-handle="' + psfEsc(p.handle) + '" data-sku="' + psfEsc(p.sku) + '">' +
                 psfActionBtn(p.handle, p.sku, p.in_stock) + '</span>';
    return '<a href="' + url + '" class="psf-card">' +
      '<div class="psf-card-tile">' + tile + '</div>' +
      '<div class="psf-card-main"><div class="psf-card-top">' +
      (p.sku ? '<span class="psf-card-sku">' + psfEsc(p.sku) + '</span><span class="psf-card-dot">\u2022</span>' : '') +
      second + '</div>' +
      '<div class="psf-card-title">' + psfEsc(psfCapTitle(p.title)) + '</div></div>' +
      '<div class="psf-card-right">' + price + action + '</div></a>';
  }

  // Add-to-cart by handle — runtime variant lookup (the index carries no variant id)
  function addByHandle(handle, btn) {
    if (!handle || (btn && btn.dataset.busy)) return;
    if (btn) { btn.dataset.busy = '1'; btn.textContent = 'Adding\u2026'; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var vs = prod.variants || [];
        var v = vs.filter(function (x) { return x.available; })[0] || vs[0];
        if (!v) throw new Error('no variant');
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.classList.add('psf-added'); btn.innerHTML = '\u2713 Added'; delete btn.dataset.busy; }
        refreshCart();
      })
      .catch(function () { if (btn) { btn.innerHTML = '+ Add'; delete btn.dataset.busy; } });
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('.cart-count-bubble span:not([aria-hidden])').forEach(function (el) { el.textContent = cart.item_count + ' items'; });
    });
    fetch('/cart.js?sections=cart-notification-product,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (data) {
      if (data.sections) {
        if (data.sections['cart-notification-product']) { var el = document.getElementById('cart-notification-product'); if (el) el.innerHTML = data.sections['cart-notification-product']; }
        if (data.sections['cart-icon-bubble']) { var el2 = document.getElementById('cart-icon-bubble'); if (el2) el2.innerHTML = data.sections['cart-icon-bubble']; }
      }
    });
  }

  /* ==============================================================
     PS Finder — search scoring
     --------------------------------------------------------------
     Replaces the old flat model (title 3 / alias 3 / everything-else 1,
     gated on every token being present somewhere).

     Two problems with that model, both causing dead-ends:
       1. No partial code matching. A customer holding the part and typing
          part of the number off it got nothing.
       2. The AND gate counted the DESCRIPTION as "present", so a stray word
          in body copy rescued irrelevant products — and one unmatched token
          binned everything, however good the other matches were.

     Tiers, high to low. Codes always outrank words.
       exact code        handled before this runs, via CODE_MAP
       code prefix       900   "LMA1" -> LMA1SPK. Reads left-to-right, like
                               a number off a box.
       code substring    600   "1SPK" -> LMA1SPK. Real, but weaker: a customer
                               reading a part usually starts at the start.
       cross-ref partial 500 / 380
       title             per-token, word-start beats mid-word
       alias             per-token, curated, ranks with title
       vendor/category   per-token
       specs             per-token, low
       desc              per-token, TINY — and never satisfies the AND gate.
                         Description can pull a near-match up the order; it
                         can no longer drag an unrelated product in.
     ============================================================== */

  function psfNormCode(s) { return (s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }

  // Light singular/singular folding. Not a real stemmer — just the endings that
  // make a word fail to match its own plural. "buddy" never matches "buddies"
  // by substring (y vs ies), which is why "bearing buddy" missed the ALKO pair
  // titled "Bearing Buddies". Fold both the query token and the indexed word to
  // a common stem before comparing. Deliberately shallow: over-stemming ("axle"
  // -> "axl") does more harm than the plurals it would catch.
  function psfStem(w) {
    if (w.length < 4) return w;
    if (/ies$/.test(w)) return w.slice(0, -3) + 'y';   // buddies -> buddy, bodies -> body
    if (/(ch|sh|ss|x|z)es$/.test(w)) return w.slice(0, -2); // boxes -> box, brushes -> brush
    if (/[^s]s$/.test(w)) return w.slice(0, -1);        // seals -> seal (but not "brass")
    return w;
  }

  // How far to trust a query as a part number.
  //   2 = full   — has a digit, 3+ chars ("HC4", "LMA1"). Prefix AND substring.
  //   1 = prefix — letters only, 3+ chars ("XDIN", "HC"). Prefix ONLY.
  //   0 = none   — too short to mean anything.
  // The middle tier exists because plenty of SKUs start with letters, and a
  // customer reading a part off a box types it left to right. Substring is
  // withheld there on purpose: an alpha substring is mostly noise, and at
  // tier weight it would let a stray SKU outrank a real word match — search
  // "seal", get some unrelated part whose number happens to contain SEAL.
  function psfCodeMode(q) {
    var n = psfNormCode(q);
    if (n.length < 2) return 0;
    if (/[0-9]/.test(n)) return n.length >= 3 ? 2 : 0;
    return n.length >= 2 ? 1 : 0;
  }

  function psfCodeScore(nq, codes, mode) {
    var best = 0;
    for (var i = 0; i < codes.length; i++) {
      var c = psfNormCode(codes[i]);
      if (!c) continue;
      if (c === nq) { return 1200; }
      if (c.indexOf(nq) === 0) { if (best < 900) best = 900; }
      else if (mode === 2 && c.indexOf(nq) !== -1) { if (best < 600) best = 600; }
    }
    return best;
  }

  function psfCrossScore(nq, codes, mode) {
    var best = 0;
    for (var i = 0; i < codes.length; i++) {
      var c = psfNormCode(codes[i]);
      if (!c) continue;
      if (c === nq) { return 1000; }
      if (c.indexOf(nq) === 0) { if (best < 500) best = 500; }
      else if (mode === 2 && c.indexOf(nq) !== -1) { if (best < 380) best = 380; }
    }
    return best;
  }

  // Word-start match scores above mid-word: "seal" should rank "Seal Kit"
  // over "Unsealed Bearing".
  // Length floors for word matching. The finder's charm is that the START of a
  // word finds it ("coup" -> coupling); the risk is a fragment so short it pulls
  // noise ("cup" landing inside "hiccup"). These set how many characters a query
  // word needs before it's allowed to match a word's start vs its middle.
  //   whole-word matches are ALWAYS allowed ("cup" always finds "Cup"),
  //   a PREFIX of a longer word needs minPrefix chars,
  //   a match INSIDE a word needs minMid chars (higher — mid-word is noisier).
  var PSF_CFG = { minPrefix: 3, minMid: 4 };

  function psfFieldScore(field, tok, atStart, inside) {
    if (!field) return 0;
    var i = field.indexOf(tok);
    if (i === -1) {
      // Singular/plural fallback. Guard hard before the expensive split:
      // the stem's leading chunk must at least appear in the field, or there
      // is no plural of it here and we skip the work entirely.
      var st = psfStem(tok);
      if (st !== tok && st.length >= 3 && field.indexOf(st.slice(0, st.length - 1)) !== -1) {
        var fw = field.split(/[^a-z0-9]+/);
        for (var k = 0; k < fw.length; k++) {
          if (fw[k] && psfStem(fw[k]) === st) return atStart;
        }
      }
      return 0;
    }
    var atWordStart = (i === 0 || /[^a-z0-9]/.test(field.charAt(i - 1)));
    var endPos = i + tok.length;
    var atWordEnd = (endPos >= field.length || /[^a-z0-9]/.test(field.charAt(endPos)));

    if (atWordStart && atWordEnd) return atStart;                          // whole word — always
    if (atWordStart) return tok.length >= PSF_CFG.minPrefix ? atStart : 0; // prefix of a longer word
    return tok.length >= PSF_CFG.minMid ? inside : 0;                      // buried inside a word
  }

  /* ==============================================================
     Fuzzy matching — greasy fingers, transposed letters
     --------------------------------------------------------------
     Deliberately narrow. Three rules keep it from doing harm:

     1. WORDS ONLY, NEVER CODES. "HC4" and "HC5" are one keystroke
        apart and are different parts. A typo-tolerant part number
        sells someone the wrong thing and nobody finds out until it
        is on the bench. Codes stay exact.

     2. THE QUERY IS CORRECTED ONCE, against a vocabulary built from
        titles, aliases, brands and categories — not fuzzy-matched
        product by product. Faster, and it means the finder knows
        WHAT it changed and can say so.

     3. IT ONLY FIRES WHEN A WORD IS FOUND NOWHERE. If the word
        exists in the catalogue, it is not a typo, and we leave it
        alone. So a correct search can never be "corrected".

     Distance scales with length, because two edits on a short word
     is a different word:
        <= 3 chars   no correction at all
        4-6 chars    1 edit
        7+ chars     2 edits, but the first letter must still match
     ============================================================== */

  // QWERTY neighbours. A finger landing one key off is the commonest
  // slip there is, and it should cost less than a random wrong letter:
  // "vearing" is a near-certain "bearing", "zearing" is anyone's guess.
  var PSF_KEYS = {
    q:'wa', w:'qeasd', e:'wrsdf', r:'etdfg', t:'ryfgh', y:'tughj', u:'yijhk',
    i:'uokjl', o:'iplk', p:'ol',
    a:'qwsz', s:'qwedazx', d:'werfsxc', f:'ertdgcv', g:'rtyfhvb', h:'tyugjbn',
    j:'yuihknm', k:'uiojlmn', l:'iopk',
    z:'asx', x:'zsdc', c:'xdfv', v:'cfgb', b:'vghn', n:'bhjm', m:'njk'
  };
  function psfAdjacent(a, b) {
    var n = PSF_KEYS[a];
    return !!n && n.indexOf(b) !== -1;
  }

  // Letters sorted = the fingerprint of an anagram. "bearnig", "baering"
  // and "gnirbae" all fingerprint identically to "bearing", so a jumble
  // of the right letters resolves in one lookup no matter how scrambled.
  function psfAnaKey(w) { return w.split('').sort().join(''); }

  var PSF_VOCAB = null;

  function psfBuildVocab(products) {
    var set = Object.create(null);
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var src = (p.title || '') + ' ' + (p.vendor || '') + ' ' + (p.category || '') + ' '
              + (p.part_type || '') + ' ' + ((p.finder && p.finder.aliases) || '');
      var w = src.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').split(/\s+/);
      for (var j = 0; j < w.length; j++) {
        // Skip pure numbers and anything code-shaped — see rule 1.
        if (w[j].length >= 3 && !/\d/.test(w[j])) set[w[j]] = 1;
      }
    }
    var list = [], ana = Object.create(null), pfx = Object.create(null);
    for (var k in set) {
      list.push(k);
      var ak = psfAnaKey(k);
      (ana[ak] = ana[ak] || []).push(k);
      // Every leading chunk of a real word (3+ chars) is a valid partial.
      // "coup" is a prefix of "coupling", so a customer typing it is mid-word,
      // not misspelling — it must never be fuzzy-corrected to "cup".
      for (var c = 3; c < k.length; c++) pfx[k.slice(0, c)] = 1;
    }
    return { set: set, list: list, ana: ana, pfx: pfx };
  }

  // Bounded Damerau-Levenshtein. Bails out as soon as it exceeds max.
  // Damerau (not plain Levenshtein) because a transposition — "bearnig"
  // for "bearing" — is ONE slip of the fingers, and counting it as two
  // edits burns the whole budget on a single fumbled keystroke.
  // Needs THREE rows: the transposition case reads the row two back.
  function psfEdits(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    if (!la) return lb; if (!lb) return la;

    var prev2 = null, prev = new Array(lb + 1), cur = new Array(lb + 1), i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;

    for (i = 1; i <= la; i++) {
      cur[0] = i;
      var best = i;
      for (j = 1; j <= lb; j++) {
        var ca = a.charAt(i - 1), cb = b.charAt(j - 1);
        // 0.6 not 0.5 on purpose: ONE neighbouring-key slip is cheap, but
        // two of them still exceed a short word's budget of 1.
        var cost = ca === cb ? 0 : (psfAdjacent(ca, cb) ? 0.6 : 1);
        var v = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 &&
            a.charAt(i - 1) === b.charAt(j - 2) &&
            a.charAt(i - 2) === b.charAt(j - 1)) {
          v = Math.min(v, prev2[j - 2] + 1);
        }
        cur[j] = v;
        if (v < best) best = v;
      }
      if (best > max) return max + 1;
      prev2 = prev; prev = cur; cur = new Array(lb + 1);
    }
    return prev[lb];
  }

  function psfMaxEdits(w) {
    if (w.length <= 3) return 0;
    if (w.length <= 6) return 1;
    return 2;
  }

  function psfCorrectToken(tok, vocab) {
    if (vocab.set[tok]) return null;             // real word — leave it alone
    if (vocab.pfx && vocab.pfx[tok]) return null; // partial of a real word — mid-type, not a typo

    // Jumbled letters first — an exact anagram is the strongest signal
    // available, and it costs one lookup regardless of how scrambled.
    // Safe because a word that IS in the catalogue never reaches here:
    // typing "stud" can never be turned into "dust".
    var cands = vocab.ana[psfAnaKey(tok)];
    if (cands && cands.length) {
      if (cands.length === 1) return cands[0];
      // Several real words share these letters — take the one closest to
      // what was actually typed, i.e. fewest letters out of position.
      var bestA = null, bestAD = Infinity;
      for (var q = 0; q < cands.length; q++) {
        var dd = psfEdits(tok, cands[q], 99);
        if (dd < bestAD) { bestAD = dd; bestA = cands[q]; }
      }
      return bestA;
    }

    var max = psfMaxEdits(tok);
    if (!max) return null;
    var bestW = null, bestD = max + 1;
    for (var i = 0; i < vocab.list.length; i++) {
      var w = vocab.list[i];
      if (Math.abs(w.length - tok.length) > max) continue;
      // At 2 edits, demand the first letter — without it precision falls
      // apart. Exception: a NEIGHBOURING key. "vearing" for "bearing" is
      // a fat finger, not a different word, and the old rule binned it.
      if (max > 1 && w.charAt(0) !== tok.charAt(0) && !psfAdjacent(tok.charAt(0), w.charAt(0))) continue;
      var d = psfEdits(tok, w, max);
      if (d < bestD) { bestD = d; bestW = w; if (d === 1) break; }
    }
    return bestD <= max ? bestW : null;
  }

  function psfScore(query, products) {
    var v = (query || '').toLowerCase().trim();
    if (!v) return [];
    var toks = v.split(/\s+/).filter(Boolean);
    var nq = psfNormCode(v);
    var codeMode = psfCodeMode(v);
    var out = [];

    // Typo pass. Only words the catalogue has never heard of get touched,
    // and each correction is recorded so the caller can say what it did.
    var fixes = [];
    if (!PSF_VOCAB || PSF_VOCAB.n !== products.length) {
      PSF_VOCAB = psfBuildVocab(products);
      PSF_VOCAB.n = products.length;
    }
    var fuzzed = new Array(toks.length);
    for (var ti = 0; ti < toks.length; ti++) {
      var fix = psfCorrectToken(toks[ti], PSF_VOCAB);
      if (fix) { fixes.push({ from: toks[ti], to: fix }); toks[ti] = fix; fuzzed[ti] = 1; }
    }

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var score = 0;

      if (codeMode) {
        var cs = p.codes || {};
        score += psfCodeScore(nq, (cs.sku || []).concat(cs.bearing || []), codeMode);
        score += psfCrossScore(nq, cs.cross || [], codeMode);
      }

      var title  = (p.title || '').toLowerCase();
      var alias  = ((p.finder && p.finder.aliases) || '').toLowerCase();
      var vendor = ((p.vendor || '') + ' ' + (p.category || '') + ' ' + (p.part_type || '')).toLowerCase();
      // p.specs is emitted by the current builder; p.keywords is the older
      // fused field. Falling back keeps this working against an index built
      // before the builder change — it just can't deweight description there.
      var specs  = (p.specs || p.keywords || '').toLowerCase();
      var desc   = (p.desc || '').toLowerCase();

      var wordScore = 0, allPresent = true, matched = [];
      for (var t = 0; t < toks.length; t++) {
        var tok = toks[t], got = 0;

        var fz = fuzzed[t] ? 0.55 : 1;   // a guess ranks below a certainty
        got = psfFieldScore(title, tok, 60 * fz, 34 * fz);
        if (!got) got = psfFieldScore(alias, tok, 55 * fz, 30 * fz);
        if (!got) got = psfFieldScore(vendor, tok, 30 * fz, 18 * fz);
        if (!got) got = psfFieldScore(specs, tok, 12 * fz, 7 * fz);

        if (got) {
          wordScore += got;
          matched[t] = 1;
        } else {
          // Description scores, but never counts as "found". A product whose
          // only link to the query is buried in body copy stays out.
          var d = psfFieldScore(desc, tok, 2, 1);
          if (d) wordScore += d;
          allPresent = false;
        }
      }

      // How the word tokens combine.
      //   code hit          -> always kept, words add to it
      //   every token found -> kept, full word score
      //   SOME tokens found -> kept, but penalised per missing token, so a
      //                        product matching 2 of 3 words still surfaces
      //                        below the ones matching all 3. Adding a word can
      //                        now only RE-RANK, never delete — which is what a
      //                        person expects when they type more, not less.
      //   nothing found     -> dropped.
      var hitCount = 0;
      for (var hc = 0; hc < matched.length; hc++) if (matched[hc]) hitCount++;

      if (score > 0) {
        score += wordScore;
      } else if (hitCount > 0) {
        var miss = toks.length - hitCount;
        // each missing word costs a flat slice; all-present pays nothing
        score = wordScore - miss * 18;
        if (score < 1) score = 1;
      } else {
        continue;
      }

      if (score > 0) {
        // Gentle nudges, deliberately small enough never to reorder tiers.
        if (p.in_stock) score += 2;
        if (p.image) score += 1;
        out.push({ p: p, score: score });
      }
    }

    out.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return (a.p.title || '').localeCompare(b.p.title || '');
    });
    out.corrections = fixes;
    return out;
  }

  function resolveViaIndex(raw, v) {
    stage('<div class="psf-qn" style="color:rgba(240,236,230,0.4)">Searching for <span style="color:#ffd525">' + raw + '</span>...</div>');
    loadIndexData(function (data) {
      if (!data) { doStoreSearch(raw); return; }
      const hit = CODE_MAP[normCode(v)];
      if (hit) {
        const p = hit.product;
        const tag = hit.type === 'cross-reference'
          ? '<div class="psf-qn" style="color:#60a5fa">Matched your cross-reference ' + raw + '</div>'
          : '<div class="psf-qn">Found it.</div>';
        stage(tag + '<div class="psf-results">' + indexResultRow(p) + '</div>' + alsoNeededHtml(p));
        return;
      }
      const scored = psfScore(v, data.products || []);
      const list = scored.slice(0, 30).map(function (x) { return x.p; });
      if (!list.length) {
        stage('<div class="psf-qn">No results for <span style="color:#ffd525">' + raw + '</span>.</div><div class="psf-phone-box" style="margin-top:12px"><p>Cannot find what you are after? Call us direct.</p><strong>(08) 8725 9299</strong><small>Mon–Fri 8am–5pm · Sat 9am–12pm</small></div><span class="psf-restart" id="psf-rs">Start Over</span>');
        $id('psf-rs').addEventListener('click', restart);
        return;
      }
      stage('<div class="psf-qn">Results for <span style="color:#ffd525">' + raw + '</span></div><div class="psf-results">' + list.map(indexResultRow).join('') + '</div>' + (list.length === 1 ? alsoNeededHtml(list[0]) : ''));
    });
  }

  // finder.also_needed \u2014 curated companion SKUs, resolved through the index
  function alsoNeededHtml(p) {
    var raw = (p.finder && p.finder.also_needed) || '';
    if (!raw) return '';
    var cards = raw.split(/[,\n;]+/).map(function (s) { return s.trim(); }).filter(Boolean)
      .map(function (sku) { var h = CODE_MAP[normCode(sku)]; return h ? h.product : null; })
      .filter(function (x) { return x && x.handle !== p.handle; })
      .map(indexResultRow).join('');
    if (!cards) return '';
    return '<div class="psf-alsohdr">In case you need it</div><div class="psf-results">' + cards + '</div>';
  }

  // ─── Battery pathway ──────────────────────────────────────────────────────────
  function doBatterySearch(raw) {
    crumbs = [raw, 'Battery']; setCrumb();
    stage('<div class="psf-qn" style="color:rgba(240,236,230,0.4)">Looking up batteries...</div>');
    loadBatteryData(function(data) {
      const v = raw.toLowerCase().replace(/battery|batteries/gi, '').trim();
      const parsed = parseBatteryInput(v, data);
      if (!parsed.make) { askBatteryVehicle(); return; }
      runBatteryFilter(parsed, raw, data);
    });
  }

  function parseBatteryInput(v, data) {
    const result = { make: null, model: null, year: null, assembly: null };

    // Year — full YYYY, MY22, or bare 2-digit
    const yearFull = v.match(/(19|20)\d{2}/);
    const yearMY = v.match(/my(\d{2})/i);
    if (yearFull) result.year = parseInt(yearFull[0]);
    else if (yearMY) result.year = 2000 + parseInt(yearMY[1]);

    // Get unique makes from loaded data
    const makes = data ? [...new Set(data.fitments.map(f => f.make).filter(Boolean))].sort() : [];

    // Try multi-word makes first (ALFA, LAND ROVER, MERCEDES-BENZ)
    // Sort by length descending so longer makes match first
    const sortedMakes = makes.slice().sort((a, b) => b.length - a.length);
    for (const make of sortedMakes) {
      if (v.toUpperCase().includes(make)) {
        result.make = make;
        // Strip make and year from input to get model
        const rest = v.toUpperCase()
          .replace(make, '')
          .replace(/(19|20)\d{2}/, '')
          .replace(/MY\d{2}/i, '')
          .trim();
        if (rest.length > 0) result.model = rest;
        break;
      }
    }

    return result;
  }

  function runBatteryFilter(parsed, raw, data) {
    let rows = data.fitments;

    // Filter by make
    if (parsed.make) rows = rows.filter(r => r.make === parsed.make);

    // Filter by model — client-side contains match
    if (parsed.model) rows = rows.filter(r => r.model && r.model.includes(parsed.model));

    // Filter by year
    if (parsed.year) {
      rows = rows.filter(r => {
        const from = r.year_from || 0;
        const to = r.year_to || 9999;
        return from <= parsed.year && to >= parsed.year;
      });
    }

    if (!rows.length) { showBatteryPhone(); return; }

    const skus = [...new Set(rows.map(r => r.sku))];
    const specs = data.specs.filter(s => skus.includes(s.sku));

    // Disambiguate body type if multiple
    const bodyTypes = [...new Set(rows.map(r => r.body_type).filter(Boolean))];
    if (bodyTypes.length > 1) { askBatteryBodyType(parsed, raw, rows, bodyTypes, data); return; }

    // Disambiguate engine if many
    const engines = [...new Set(rows.map(r => r.engine).filter(Boolean))];
    if (engines.length > 3 && !parsed.engine) { askBatteryEngine(parsed, raw, rows, engines, data); return; }

    showBatteryResults(specs, rows, parsed);
  }

  function showBatteryPhone() {
    stage('<div class="psf-qn">No battery found for that search.</div><div class="psf-phone-box" style="margin-top:12px"><p>Give us a call — we will find the right battery.</p><strong>(08) 8725 9299</strong><small>Mon–Fri 8am–5pm · Sat 9am–12pm</small></div><span class="psf-restart" id="psf-rs">Start Over</span>');
    $id('psf-rs').addEventListener('click', restart);
  }

  function askBatteryVehicle() {
    stage('<div class="psf-q">What Vehicle?</div><div class="psf-qn">Type make, model and year — e.g. Ford Ranger 2022, Toyota Hilux 2019</div><div class="psf-search-input-wrap"><input id="psf-bat-input" placeholder="e.g. Ford Ranger 2022" autocomplete="off"><button id="psf-bat-search">Search</button></div><div class="psf-divider"></div><div class="psf-q" style="margin-bottom:6px">Or search by spec:</div><div class="psf-opts"><div class="psf-opt" id="bat-cca">I know the CCA rating</div><div class="psf-opt" id="bat-size">I know the size code (e.g. DIN77)</div><div class="psf-opt" id="bat-partnum">I have a part number</div></div><div class="psf-divider"></div><div class="psf-opts"><div class="psf-opt psf-opt-muted" id="bat-all">See the full Exide range \u2192</div></div><span class="psf-restart" id="psf-rs">Start Over</span>');
    const doSearch = () => { const val = ($id('psf-bat-input') || {value:''}).value.trim(); if (val) doBatterySearch(val + ' battery'); };
    $id('psf-bat-search').addEventListener('click', doSearch);
    $id('psf-bat-input').addEventListener('keydown', e => { if (e.key === 'Enter') { doSearch(); e.target.blur(); } });
    $id('bat-cca').addEventListener('click', () => askBatterySpec('cca'));
    $id('bat-size').addEventListener('click', () => askBatterySpec('size'));
    $id('bat-partnum').addEventListener('click', () => askBatterySpec('sku'));
    $id('bat-all').addEventListener('click', () => { window.location.href = '/collections/exide'; });
    $id('psf-rs').addEventListener('click', restart);
  }

  function batterySizeSearch(val) {
    loadIndexData(function (data) {
      if (!data) { showBatteryPhone(); return; }
      const list = (data.products || []).filter(function (p) {
        if (p.part_type !== 'battery') return false;
        const sz = ((p.finder && p.finder.battery_size) || '').toUpperCase();
        const sku = (p.sku || '').toUpperCase();
        const title = (p.title || '').toUpperCase();
        return sz.indexOf(val) !== -1 || sku.indexOf(val) !== -1 || title.indexOf(val) !== -1;
      }).slice(0, 20);
      if (!list.length) { showBatteryPhone(); return; }
      stage('<div class="psf-qn">Batteries matching <span style="color:#ffd525">' + val + '</span></div><div class="psf-results">' + list.map(indexResultRow).join('') + '</div><span class="psf-restart" id="psf-rs">Start Over</span>');
      $id('psf-rs').addEventListener('click', restart);
    });
  }

  function askBatterySpec(type) {
    const labels = {cca:'CCA Rating', size:'Size Code (e.g. DIN77)', sku:'Part Number'};
    const placeholders = {cca:'e.g. 600', size:'e.g. DIN77', sku:'e.g. XDIN77MF'};
    stage('<div class="psf-q">What ' + labels[type] + '?</div><div class="psf-search-input-wrap"><input id="psf-spec-input" placeholder="' + placeholders[type] + '" autocomplete="off"><button id="psf-spec-search">Search</button></div><span class="psf-restart" id="psf-rs">Start Over</span>');
    const doSearch = () => {
      const val = ($id('psf-spec-input') || {value:''}).value.trim().toUpperCase();
      if (!val) return;
      stage('<div class="psf-qn" style="color:rgba(240,236,230,0.4)">Searching...</div>');
      if (type === 'sku') { resolveViaIndex(val, val.toLowerCase()); return; }
      if (type === 'size') { batterySizeSearch(val); return; }
      loadBatteryData(function(data) {
        const specs = data.specs.filter(s => s.cca && String(s.cca) === val);
        if (!specs.length) { showBatteryPhone(); return; }
        showBatteryResults(specs, [], {});
      });
    };
    $id('psf-spec-search').addEventListener('click', doSearch);
    $id('psf-spec-input').addEventListener('keydown', e => { if (e.key === 'Enter') { doSearch(); e.target.blur(); } });
    $id('psf-rs').addEventListener('click', restart);
  }

  function askBatteryBodyType(parsed, raw, rows, bodyTypes, data) {
    const opts = bodyTypes.map(bt => '<div class="psf-opt psf-bt-opt" data-bt="' + bt + '">' + bt + '</div>').join('');
    stage('<div class="psf-q">Which Body Type?</div><div class="psf-opts">' + opts + '<div class="psf-opt psf-opt-muted" id="bt-ns">Not Sure — Show All</div></div><span class="psf-restart" id="psf-rs">Start Over</span>');
    document.querySelectorAll('.psf-bt-opt').forEach(b => {
      b.addEventListener('click', function() {
        crumbs.push(this.dataset.bt); setCrumb();
        const filtered = rows.filter(r => r.body_type === this.dataset.bt);
        const skus = [...new Set(filtered.map(r => r.sku))];
        showBatteryResults(data.specs.filter(s => skus.includes(s.sku)), filtered, parsed);
      });
    });
    $id('bt-ns').addEventListener('click', () => {
      const skus = [...new Set(rows.map(r => r.sku))];
      showBatteryResults(data.specs.filter(s => skus.includes(s.sku)), rows, parsed);
    });
    $id('psf-rs').addEventListener('click', restart);
  }

  function askBatteryEngine(parsed, raw, rows, engines, data) {
    const opts = engines.slice(0, 8).map(e => '<div class="psf-opt psf-eng-opt" data-eng="' + e + '">' + e + '</div>').join('');
    stage('<div class="psf-q">Which Engine?</div><div class="psf-opts">' + opts + '<div class="psf-opt psf-opt-muted" id="eng-ns">Not Sure — Show All</div></div><span class="psf-restart" id="psf-rs">Start Over</span>');
    document.querySelectorAll('.psf-eng-opt').forEach(b => {
      b.addEventListener('click', function() {
        crumbs.push(this.dataset.eng); setCrumb();
        const filtered = rows.filter(r => r.engine === this.dataset.eng);
        const skus = [...new Set(filtered.map(r => r.sku))];
        showBatteryResults(data.specs.filter(s => skus.includes(s.sku)), filtered, parsed);
      });
    });
    $id('eng-ns').addEventListener('click', () => {
      const skus = [...new Set(rows.map(r => r.sku))];
      showBatteryResults(data.specs.filter(s => skus.includes(s.sku)), rows, parsed);
    });
    $id('psf-rs').addEventListener('click', restart);
  }

  // Assembly polarity labels
  const ASSEMBLY_LABELS = {
    'A': 'Positive Bottom Right (A)',
    'C': 'Positive Right (C)',
    'D': 'Positive Left (D)',
    'E': 'Positive Bottom Right (E)',
    'F': 'Positive Top Right (F)',
    'G': 'Positive Bottom Right (G)',
    'H': 'Positive Left (H)',
  };

  function askBatteryTerminal(specs, fitments, parsed) {
    const assemblies = [...new Set(specs.map(s => s.assembly).filter(Boolean))];
    const opts = assemblies.map(a => '<div class="psf-opt psf-asm-opt" data-asm="' + a + '">' + (ASSEMBLY_LABELS[a] || 'Assembly ' + a) + '</div>').join('');
    stage('<div class="psf-q">Which Terminal Position?</div><div class="psf-qn">Check the positive (+) terminal position on your existing battery.</div><div class="psf-opts">' + opts + '<div class="psf-opt psf-opt-muted" id="term-ns">Not Sure — Show All</div></div><span class="psf-restart" id="psf-rs">Start Over</span>');
    document.querySelectorAll('.psf-asm-opt').forEach(b => {
      b.addEventListener('click', function() {
        parsed.assembly = this.dataset.asm;
        crumbs.push(ASSEMBLY_LABELS[this.dataset.asm] || this.dataset.asm); setCrumb();
        showBatteryResults(specs, fitments, parsed);
      });
    });
    $id('term-ns').addEventListener('click', () => showBatteryResults(specs, fitments, parsed));
    $id('psf-rs').addEventListener('click', restart);
  }

  function showBatteryResults(specs, fitments, parsed, skipGate) {
    if (!specs || !specs.length) { showBatteryPhone(); return; }
    const assemblies = [...new Set(specs.map(s => s.assembly).filter(Boolean))];
    if (assemblies.length > 1 && !parsed.assembly && !skipGate) {
      askBatteryTerminal(specs, fitments, parsed); return;
    }
    let finalSpecs = specs;
    if (parsed.assembly) {
      const filtered = specs.filter(s => s.assembly === parsed.assembly);
      if (filtered.length) finalSpecs = filtered;
    }
    let rowsHtml = '';
    finalSpecs.forEach(spec => {
      const isDone = added['bat-' + spec.sku];
      const detail = [
        spec.cca ? spec.cca + ' CCA' : '',
        spec.ah ? spec.ah + 'Ah' : '',
        spec.size || '',
        spec.dimensions ? spec.dimensions + ' mm' : '',
        spec.assembly ? (ASSEMBLY_LABELS[spec.assembly] || 'Assembly ' + spec.assembly) : '',
      ].filter(Boolean).join(' · ');
      var bp = (CODE_MAP) ? (CODE_MAP[normCode(spec.sku)] || {}).product : null;
      var btile = (bp && bp.image)
        ? '<img class="psf-photo" src="' + psfEsc(psfImg(bp.image)) + '" alt="" loading="lazy">'
        : '<img class="psf-wm" src="' + PSF_WM + '" alt="" loading="lazy">';
      var btop = '<span class="psf-card-sku">' + psfEsc(spec.sku) + '</span>' +
        '<span class="psf-card-dot">\u2022</span>' +
        ((bp && bp.freight)
          ? '<span class="psf-freight">Freight Quote Req.</span>'
          : '<span class="psf-card-vendor">' + psfEsc((bp && bp.vendor) || spec.range || 'Exide') + '</span>');
      var bprice = (bp && bp.price) ? '<div class="psf-card-price"><b>$' + psfEsc(bp.price) + '</b></div>' : '';
      var bname = (bp && bp.title) ? bp.title : ((spec.range || 'Exide') + ' \u2014 ' + spec.sku);
      var binner = '<div class="psf-card-tile">' + btile + '</div>' +
        '<div class="psf-card-main"><div class="psf-card-top">' + btop + '</div>' +
        '<div class="psf-card-title">' + psfEsc(bname) + '</div>' +
        (detail ? '<div class="psf-card-detail">' + psfEsc(detail) + '</div>' : '') + '</div>' +
        '<div class="psf-card-right">' + bprice +
        '<button class="psf-add' + (isDone ? ' psf-done' : '') + '" id="add-bat-' + psfEsc(spec.sku) + '" data-sku="' + psfEsc(spec.sku) + '">' + (isDone ? 'Added \u2713' : '+ Add') + '</button></div>';
      rowsHtml += (bp && bp.handle)
        ? '<a href="/products/' + psfEsc(bp.handle) + '" class="psf-card">' + binner + '</a>'
        : '<div class="psf-card">' + binner + '</div>';
    });
    stage('<div class="psf-kit-hdr"><span class="psf-kit-hdr-title">Battery Match</span><span class="psf-badge psf-badge-red">' + finalSpecs.length + ' Result' + (finalSpecs.length !== 1 ? 's' : '') + '</span></div><div class="psf-results">' + rowsHtml + '</div>');
    finalSpecs.forEach(spec => {
      const btn = $id('add-bat-' + spec.sku);
      if (!btn) return;
      if (added['bat-' + spec.sku]) { btn.innerHTML = 'Added \u2713'; btn.classList.add('psf-done'); }
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        added['bat-' + spec.sku] = true;
        this.innerHTML = 'Added \u2713';
        this.classList.add('psf-done');
        var bp2 = (CODE_MAP) ? (CODE_MAP[normCode(spec.sku)] || {}).product : null;
        if (VARIANT_IDS[spec.sku]) addToCart([spec.sku], this);
        else if (bp2 && bp2.handle) addByHandle(bp2.handle, this);
      });
    });
  }

  // ─── Store catalogue fallback search ─────────────────────────────────────────
  function doStoreSearch(term) {
    stage('<div class="psf-qn" style="color:rgba(240,236,230,0.4)">Searching catalogue for <span style="color:#ffd525">' + term + '</span>...</div>');
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8')
      .then(r => r.json())
      .then(data => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          stage('<div class="psf-qn">No results for <span style="color:#ffd525">' + term + '</span>.</div><div class="psf-phone-box" style="margin-top:12px"><p>Cannot find what you are after? Call us direct.</p><strong>(08) 8725 9299</strong><small>Mon–Fri 8am–5pm · Sat 9am–12pm</small></div><span class="psf-restart" id="psf-rs">Start Over</span>');
          $id('psf-rs').addEventListener('click', restart);
          return;
        }
        let rowsHtml = '';
        products.forEach(p => {
          rowsHtml += '<a href="' + p.url + '" class="psf-search-result" style="text-decoration:none"><div class="psf-sr-info"><div class="psf-sr-title">' + p.title + '</div>' + (p.price ? '<div class="psf-sr-price">' + p.price + '</div>' : '') + '</div><span class="psf-sr-arrow">&#8594;</span></a>';
        });
        stage('<div class="psf-qn">Showing store results for <span style="color:#ffd525">' + term + '</span></div><div class="psf-results">' + rowsHtml + '</div><span class="psf-restart" id="psf-rs">Start Over</span>');
        $id('psf-rs').addEventListener('click', restart);
      })
      .catch(() => {
        stage('<div class="psf-phone-box"><p>Search unavailable. Call us direct.</p><strong>(08) 8725 9299</strong><small>Mon–Fri 8am–5pm · Sat 9am–12pm</small></div><span class="psf-restart" id="psf-rs">Start Over</span>');
        $id('psf-rs').addEventListener('click', restart);
      });
  }

  // ─── Input processing ─────────────────────────────────────────────────────────
  var EXAMPLES = [
    { term: 'hub', note: 'guided \u2014 build the right kit' },
    { term: 'battery', note: 'find by your vehicle' },
    { term: 'S56318', note: "a competitor's code" },
    { term: 'LM67048', note: 'a bearing number' },
    { term: 'mudguard', note: 'just search' }
  ];
  function remember(term) {
    try {
      var arr = JSON.parse(sessionStorage.getItem('psfRecent') || '[]');
      arr = arr.filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
      arr.unshift(term); arr = arr.slice(0, 5);
      sessionStorage.setItem('psfRecent', JSON.stringify(arr));
    } catch (e) {}
  }
  function getRecent() { try { return JSON.parse(sessionStorage.getItem('psfRecent') || '[]'); } catch (e) { return []; } }

  // ── Pinned products (device-local, shared with the product page) ──
  // localStorage key 'psfPins', each { handle, title, sku }. Written from the
  // product-page "Pin to Finder" button; read + removable here. No account —
  // this is how saved parts work now that the customer section is gone.
  function getPins() {
    try { var a = JSON.parse(localStorage.getItem('psfPins') || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function removePin(handle) {
    try {
      var a = getPins().filter(function (p) { return p.handle !== handle; });
      localStorage.setItem('psfPins', JSON.stringify(a));
    } catch (e) {}
  }
  function pinnedHtml() {
    var pins = getPins();
    if (!pins.length) return '';
    // Full-width rows like the example rows: SKU stacked above title, trashcan
    // right. Tapping the row body opens the product; the trash removes the pin.
    var rows = pins.map(function (p) {
      return '<div class="psf-pin" data-handle="' + psfEsc(p.handle) + '">' +
        '<a class="psf-pin-hit" href="/products/' + psfEsc(p.handle) + '">' +
        '<span class="psf-pin-sku">' + psfEsc(p.sku || '') + '</span>' +
        '<span class="psf-pin-title">' + psfEsc(p.title || p.handle) + '</span>' +
        '</a>' +
        '<button class="psf-pin-trash" data-pin-remove="' + psfEsc(p.handle) + '" aria-label="Remove pin" type="button">' +
        '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 13a2 2 0 002 2h8a2 2 0 002-2l1-13M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/></svg>' +
        '</button></div>';
    }).join('');
    return '<div class="psf-ex-hd" style="margin-top:20px">Pinned products</div>' +
      '<div class="psf-ex-list">' + rows + '</div>' +
      '<div class="psf-pin-disclaim">Pins are saved on this device only. Clearing browser history removes them.</div>';
  }

  function showEmptyState() {
    crumbs = []; setCrumb();
    var ex = EXAMPLES.map(function (e) {
      return '<button class="psf-ex" data-term="' + psfEsc(e.term) + '"><span class="psf-ex-term">' + psfEsc(e.term) + '</span><span class="psf-ex-note">' + psfEsc(e.note) + '</span></button>';
    }).join('');
    var recent = getRecent();
    var rec = recent.length
      ? '<div class="psf-ex-hd" style="margin-top:20px">Recent searches</div><div class="psf-recent">' + recent.map(function (t) { return '<button class="psf-chip" data-term="' + psfEsc(t) + '">' + psfEsc(t) + '</button>'; }).join('') + '</div>'
      : '';
    // Order is fixed: Examples → Recent → Pinned, each shown only when populated.
    stage('<div class="psf-ex-hd">Try one of these</div><div class="psf-ex-list">' + ex + '</div>' + rec + pinnedHtml());
  }

  // ── Search as you type ─────────────────────────────────────────────────────
  // Fire the search a short beat after typing STOPS, not on every keystroke.
  // The beat is longer on touch devices: phones type slower and burstier, and
  // every fired search re-renders the list (which on mobile fights the on-screen
  // keyboard), so fewer fires is calmer. Enter still fires immediately — this is
  // additive, the commit path is untouched.
  var PSF_DEBOUNCE = (window.matchMedia &&
    (window.matchMedia('(pointer: coarse)').matches ||
     window.matchMedia('(max-width: 749px)').matches)) ? 250 : 120;
  var PSF_LIVE_MIN = 2;              // don't fire the live search below this many chars
  var psfLiveTimer = null;
  var psfLiveLast = null;           // guard: don't re-run an unchanged query

  function psfLiveSearch(v) {
    clearTimeout(psfLiveTimer);
    var q = (v || '').trim();
    // Below the floor: cancel any pending fire and leave the panel as-is
    // (empty state / examples). Enter still works at any length.
    if (q.length < PSF_LIVE_MIN) { psfLiveLast = null; return; }
    psfLiveTimer = setTimeout(function () {
      if (q === psfLiveLast) return;   // same as what's already shown — skip
      psfLiveLast = q;
      processInput(q);
    }, PSF_DEBOUNCE);
  }

  function processInput(v, commit) {
    const raw = v; v = v.toLowerCase().trim();
    if (!v) return;
    // Only record COMMITTED searches (Enter or a tapped example/recent chip).
    // The live search-as-you-type path calls this with commit=false, so typing
    // "jockey wheel" no longer saves "jockey w", "jockey wh"... as five entries.
    if (commit) remember(raw);
    crumbs = []; setCrumb();

    // 1. Bare tree-word (typed on its own) fires that tree
    if (v === 'battery' || v === 'batteries') { crumbs = ['Battery']; setCrumb(); askBatteryVehicle(); return; }
    if (v === 'hub') { crumbs = ['Hub']; setCrumb(); doHubSearch(null, null, false, false); return; }
    if (v === 'bearing' || v === 'bearing kit' || v === 'seal kit') { crumbs = ['Bearing']; setCrumb(); doBearingSearch(); return; }
    if (v === 'jockey wheel') { crumbs = [{ label: 'Jockey Wheel', pathway: true }]; setCrumb(); doJockeyWheel(); return; }

    // 2. Known bearing race numbers keep their rich result (unchanged)
    const raceA = ['lm67048','lm67049','lm67010','lm11949','lm11910'];
    const raceB = ['l68149','l68110','lm12749','lm12710'];
    const race2T = ['25580','25520','15123','15245','2te-lc6'];
    const race3T = ['30210','29749','29710','3tf-lc6'];
    if (raceA.some(function (r) { return v.includes(r); })) { crumbs = ['Bearing', 'NSK (A)']; setCrumb(); showBearingResult('A', false, false, null); return; }
    if (raceB.some(function (r) { return v.includes(r); })) { crumbs = ['Bearing', 'NSK (B)']; setCrumb(); showBearingResult('B', false, false, null); return; }
    if (race2T.some(function (r) { return v.includes(r); })) { showBearingResult('2TE-LC6', true, false, null); return; }
    if (race3T.some(function (r) { return v.includes(r); })) { showBearingResult('3TF-LC6', true, false, null); return; }

    // 3. Everything else resolves against the finder index (exact code, then keyword)
    resolveViaIndex(raw, v);
  }

  // ─── Restart ──────────────────────────────────────────────────────────────────
  function restart() {
    added = {}; crumbs = []; setCrumb();
psfLiveLast = null; clearTimeout(psfLiveTimer);

    $id('psf-input').value = '';
    if ($id('psf-clear')) $id('psf-clear').style.display = 'none';
    showEmptyState();
    $id('psf-input').focus();
  }

  // ─── Overlay open / close ─────────────────────────────────────────────────────
  function openFinder() {
    const overlay = $id('psf-overlay');
    if (!overlay) return;
    if (!batteryData && !batteryLoading) loadBatteryData(function() {}); // preload silently
    if (!indexData && !indexLoading) loadIndexData(function() {}); // preload the finder index silently
    // If Dawn's own search opened (e.g. it beat us to the tap on mobile), close it so it isn't left behind the finder
    document.querySelectorAll('.header__search details[open], details-modal details[open]').forEach(function (d) { d.removeAttribute('open'); });
    scrollY = window.scrollY;
    overlay.classList.add('psf-open');
    // Hiding the body scrollbar removes its width, and because the finder is
    // centred, half that width shows up as a jump to the left. Reserve exactly
    // the scrollbar's width as right padding while the finder is open, so the
    // page behind doesn't reflow and nothing shifts. innerWidth - clientWidth
    // is the live scrollbar width (0 on overlay-scrollbar systems / mobile, so
    // this is a no-op there).
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    if (!$id('psf-input').value.trim()) showEmptyState();
    setTimeout(() => $id('psf-input').focus(), 100);
  }

  function closeFinder() {
    const overlay = $id('psf-overlay');
    if (!overlay) return;
    overlay.classList.remove('psf-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────
  // ─── Back to finder ───────────────────────────────────────────────
  // The finder is an overlay with no page of its own, so the browser BACK button
  // can't return a customer to their results. Instead: a result tap stashes the
  // search, and the product page it leads to injects a context-aware strip that
  // reopens the finder with those results restored. Text searches only (a pathway
  // state has no query to re-run). Single-hop: cleared once shown.
  function psfStashBack() {
    var inp = $id('psf-input');
    var q = inp ? (inp.value || '').trim() : '';
    if (!q) return;
    var n = document.querySelectorAll('#psf-stage .psf-card').length;
    try { sessionStorage.setItem('psfBack', JSON.stringify({ q: q, n: n, t: Date.now() })); } catch (e) {}
  }

  function psfRestoreSearch(q) {
    openFinder();
    loadIndexData(function () {
      var inp = $id('psf-input');
      if (inp) inp.value = q;
      var clr = $id('psf-clear');
      if (clr) clr.style.display = '';
      psfLiveLast = q;
      processInput(q, false);
    });
  }

  function psfStashPins() {
    try { sessionStorage.setItem('psfBack', JSON.stringify({ kind: 'pins', t: Date.now() })); } catch (e) {}
  }

  function psfRestorePins() {
    var inp = $id('psf-input');
    if (inp) inp.value = '';
    var clr = $id('psf-clear');
    if (clr) clr.style.display = 'none';
    openFinder();   // empty input → showEmptyState() re-renders the pin list
  }

  function psfMaybeShowBackBar() {
    var host = document.querySelector('[id^="MainProduct-"]');
    if (!host) return;                         // not a product page
    var raw;
    try { raw = sessionStorage.getItem('psfBack'); } catch (e) { return; }
    if (!raw) return;
    try { sessionStorage.removeItem('psfBack'); } catch (e) {}   // consume — single hop
    var data; try { data = JSON.parse(raw); } catch (e) { return; }
    if (!data) return;
    if (Date.now() - (data.t || 0) > 1800000) return;            // stale after 30 min
    if (document.getElementById('psf-backbar')) return;
    var isPins = data.kind === 'pins';
    if (!isPins && !data.q) return;                              // a search needs its query
    var bar = document.createElement('button');
    bar.id = 'psf-backbar';
    bar.type = 'button';
    bar.className = 'psf-backbar';
    if (isPins) {
      bar.innerHTML =
        '<svg class="psf-backbar-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6l6 6"/></svg>' +
        '<span class="psf-backbar-label">Back to your pins</span>';
      bar.addEventListener('click', psfRestorePins);
    } else {
      bar.innerHTML =
        '<svg class="psf-backbar-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6l6 6"/></svg>' +
        '<span class="psf-backbar-label">Back to finder</span>' +
        '<span class="psf-backbar-meta">' + psfEsc(data.q) +
        (data.n ? ' \u00B7 ' + data.n + ' result' + (data.n === 1 ? '' : 's') : '') + '</span>';
      bar.addEventListener('click', function () { psfRestoreSearch(data.q); });
    }
    // Inject ABOVE #MainProduct (into the 0-padding .shopify-section wrapper) so the
    // section's own top padding becomes breathing room below the strip, not a gap above
    // it. Falls back to first-child if there's no parent.
    if (host.parentNode) host.parentNode.insertBefore(bar, host);
    else host.insertBefore(bar, host.firstChild);
  }

  function init() {
    const overlay = $id('psf-overlay');
    if (!overlay) return;

    // Close triggers
    $id('psf-close').addEventListener('click', closeFinder);

    // ── Back to finder: stash the search on a result tap; show the way back
    // on the product page it leads to. ──
    var psfStageBar = $id('psf-stage');
    if (psfStageBar) psfStageBar.addEventListener('click', function (e) {
      if (e.target.closest('.psf-add') || e.target.closest('.psf-call')) return;
      if (e.target.closest('a.psf-card')) psfStashBack();
      else if (e.target.closest('a.psf-pin-hit')) psfStashPins();
    });
    psfMaybeShowBackBar();

    // Outside/backdrop click no longer closes the finder — only the Close Finder
    // button (and Escape) do. (This also makes the old drag-select-closes bug moot.)
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeFinder(); });

    // Back button to close
    window.addEventListener('popstate', () => { if (overlay.classList.contains('psf-open')) closeFinder(); });

    // Search input enter key
    $id('psf-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && this.value.trim()) {
        clearTimeout(psfLiveTimer);            // cancel the pending live fire
        psfLiveLast = this.value.trim();       // Enter commits this exact query
        processInput(this.value.trim(), true);
        this.blur();
      }
    });

    // clear (X) + show it only when there's text
    var psfClear = $id('psf-clear');
    if (psfClear) psfClear.addEventListener('click', restart);
    $id('psf-input').addEventListener('input', function () {
      if (psfClear) psfClear.style.display = this.value ? 'flex' : 'none';
      psfLiveSearch(this.value);
    });

    // Result-card actions + example/recent taps — delegated so they survive re-renders
    var psfStage = $id('psf-stage');
    if (psfStage) psfStage.addEventListener('click', function (e) {
      var add = e.target.closest ? e.target.closest('.psf-add') : null;
      if (add) {
        e.preventDefault(); // never let the card link navigate when Add is tapped
        if (add.hasAttribute('data-handle')) { e.stopPropagation(); addByHandle(add.getAttribute('data-handle'), add); }
        return;
      }
      var call = e.target.closest ? e.target.closest('.psf-call') : null;
      if (call) { e.preventDefault(); e.stopPropagation(); window.location.href = 'tel:0887259299'; return; }
      var trash = e.target.closest ? e.target.closest('.psf-pin-trash') : null;
      if (trash) {
        e.preventDefault(); e.stopPropagation();   // don't follow the row's product link
        removePin(trash.getAttribute('data-pin-remove'));
        showEmptyState();                            // re-render; section vanishes when last pin goes
        return;
      }
      var ex = e.target.closest ? e.target.closest('.psf-ex, .psf-chip') : null;
      if (ex) { var t = ex.getAttribute('data-term'); $id('psf-input').value = t; if (psfClear) psfClear.style.display = 'flex'; processInput(t, true); }
    });

    // Intercept search triggers by DELEGATION on the document, not by binding each
    // element at load. Dawn re-renders the mobile search when the sticky header
    // re-reveals on scroll, which orphaned the old per-element bindings (real mobile
    // only). Delegation catches the trigger no matter when it enters the DOM, and
    // covers every entry point: the header search (both instances) and the homepage
    // "Search parts" link.
    var PSF_TRIGGERS = '[data-psf-open], [data-action="toggle-search"], .search-modal__toggle, #Search-In-Modal, .header__icon--search, .ps-mast__search-link';
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest(PSF_TRIGGERS) : null;
      if (t) { e.preventDefault(); openFinder(); }
    });
    document.addEventListener('focusin', function (e) {
      var i = e.target;
      if (i && i.matches && i.matches('input[type="search"], input.search__input') && i.closest('.search-modal')) {
        openFinder();
      }
    });

    // Back-to-top (mobile only, CSS-gated). #psf-overlay is the scroll element;
    // once scrolled past a threshold the button fades in, and a tap returns to
    // the top where the search field sits — ready to type a fresh term.
    var psfTop = $id('psf-top');
    if (psfTop) {
      psfTop.addEventListener('click', function () { overlay.scrollTo({ top: 0, behavior: 'smooth' }); });
      overlay.addEventListener('scroll', function () {
        if (overlay.scrollTop > 300) psfTop.classList.add('psf-top-on');
        else psfTop.classList.remove('psf-top-on');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
